<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="33rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มพนักงานใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ employeeInit.firstname_th }} {{ employeeInit.lastname_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employeeInit.employee_code }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="d-flex flex-column" style="height: 100%">
          <v-tabs v-model="tabs">
            <v-tab>
              ข้อมูลทั่วไป
              <span class="red--text ml-1"><strong>*</strong></span>
            </v-tab>
            <v-tab class="text-capitalize">การระบุตัวตน</v-tab>
            <v-tab class="text-capitalize"
              >Work Summary
              <span class="red--text ml-1"><strong>*</strong></span>
            </v-tab>
            <v-tab
              class="text-capitalize"
              :disabled="
                uiCtrl &&
                !uiCtrl.isEnable('tab:::offsite_grant:list-get-update')
              "
              >ลงเวลาผ่านมือถือ</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tabs" style="height: 100%">
            <v-tab-item
              class="px-6 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <div class="d-flex">
                <div class="mr-4">
                  <v-list-item-avatar rounded size="64" class="mx-0 my-0">
                    <v-img
                      v-if="uploadFilePreview"
                      style="width: 64px"
                      :src="'data:image/jpeg;base64,' + uploadFilePreview"
                      aspect-ratio="1"
                    ></v-img>
                    <v-img
                      v-else-if="employee.url_photo_identifier"
                      style="width: 64px"
                      :src="employee.url_photo_identifier"
                      aspect-ratio="1"
                    ></v-img>
                    <v-avatar v-else tile color="grey lighten-4" size="64">
                      <v-icon color="grey lighten-1" large>mdi-account</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                </div>
                <div class="flex-grow-1" style="position: relative">
                  <v-file-input
                    :rules="[
                      (value) =>
                        !value ||
                        value.size < 2000000 ||
                        'Image size should be less than 2 MB!',
                    ]"
                    class="fix-google-chrome"
                    v-model="fileImage"
                    ref="imgFileInput"
                    accept="image/jpeg"
                    show-size
                    @change="onFileChange"
                    @click:clear="onFileClear"
                    outlined
                    dense
                    hide-details
                  >
                  </v-file-input>
                  <v-btn
                    style="position: absolute; bottom: -5px; left: -5px"
                    :disabled="
                      !employee.url_photo_identifier ||
                      (uiCtrl &&
                        !uiCtrl.isEnable(
                          'btn:::employee:photo-identifier:delete'
                        ))
                    "
                    icon
                    class="mr-3"
                    @click="handleDeleteEmployeePhotoIdentifier"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <div
                    class="mt-1 caption"
                    style="position: absolute; right: 0"
                  >
                    <span>jpeg เท่านั้น, </span>
                    <span>ขนาดไฟล์ไม่เกิน 2Mb</span>
                  </div>
                </div>
              </div>

              <div class="mt-6">
                <label class="body-2">สถานะพนักงาน</label>
                <v-switch
                  class="mt-0 caption"
                  v-model="employee.is_active"
                  :label="employee.is_active ? 'Active' : 'Not Active'"
                >
                  <template v-slot:label>
                    <span
                      class="caption ml-2 grey--text text--darken-3 font-weight-medium"
                    >
                      {{ employee.is_active ? 'Active' : 'Not Active' }}
                    </span>
                  </template>
                </v-switch>
              </div>

              <div>
                <label class="body-2">
                  รหัสอ้างอิงพนักงาน
                  <span
                    v-if="company.is_employee_reference_code"
                    class="red--text"
                  >
                    <strong>*</strong>
                  </span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="0"
                  v-model="employee.employee_reference_code"
                  :rules="
                    company.is_employee_reference_code
                      ? [
                          (v) => !!v || 'โปรดระบุรหัสอ้างอิงพนักงาน',
                          (v) =>
                            (v && v.length >= 1 && v.length <= 32) ||
                            'รหัสพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                        ]
                      : []
                  "
                  required
                  clearable
                  @change="checkEmpty($event, 'employee_reference_code')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">
                  รหัสพนักงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="1"
                  v-model="employee.employee_code"
                  :rules="[
                    (v) => !!v || 'โปรดระบุรหัสพนักงาน',
                    (v) =>
                      (v && v.length >= 1 && v.length <= 32) ||
                      'รหัสพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                  ]"
                  required
                  clearable
                  @change="checkEmpty($event, 'employee_code')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">คำนำหน้าชื่อ</label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="2"
                  v-model="employee.company_prefix_uuid"
                  :items="prefixs"
                  item-text="title_th"
                  item-value="company_prefix_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  ชื่อ
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="3"
                  v-model="employee.firstname_th"
                  :rules="[
                    (v) => !!v || 'โปรดระบุชื่อ',
                    (v) =>
                      !v ||
                      (v && v.length <= 45) ||
                      'ชื่อต้องน้อยกว่า 45 ตัวอักษร',
                  ]"
                  required
                  clearable
                  @change="checkEmpty($event, 'firstname_th')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">
                  นามสกุล
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="4"
                  v-model="employee.lastname_th"
                  :rules="[
                    (v) => !!v || 'โปรดระบุนามสกุล',
                    (v) =>
                      !v ||
                      (v && v.length <= 80) ||
                      'นามสกุลต้องน้อยกว่า 80 ตัวอักษร',
                  ]"
                  required
                  clearable
                  @change="checkEmpty($event, 'lastname_th')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">ชื่อ (อังกฤษ)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="5"
                  v-model="employee.firstname_en"
                  :rules="[
                    (v) =>
                      !v ||
                      (v && v.length <= 45) ||
                      'ชื่อต้องน้อยกว่า 45 ตัวอักษร',
                  ]"
                  clearable
                  @change="checkEmpty($event, 'firstname_en')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">นามสกุล (อังกฤษ)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="6"
                  v-model="employee.lastname_en"
                  :rules="[
                    (v) =>
                      !v ||
                      (v && v.length <= 80) ||
                      'นามสกุลต้องน้อยกว่า 80 ตัวอักษร',
                  ]"
                  clearable
                  @change="checkEmpty($event, 'lastname_en')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">เพศ</label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="7"
                  v-model="employee.gender_id"
                  :items="genders"
                  item-text="title_th"
                  item-value="gender_id"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">เบอร์โทรศัพท์มือถือ</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="8"
                  v-model="employee.phone_no"
                  clearable
                  :rules="[
                    (v) =>
                      !v ||
                      /^\d+$/.test(v) ||
                      'เบอร์โทรศัพท์มือถือต้องเป็นตัวเลขเท่านั้น',
                    (v) =>
                      !v ||
                      v.charAt(0) === '0' ||
                      'เบอร์โทรศัพท์มือถือต้องขึ้นต้นด้วย 0',
                    (v) =>
                      !v ||
                      (v && v.length === 10) ||
                      'เบอร์โทรศัพท์มือถือต้องเท่ากับ 10',
                  ]"
                  @change="checkEmpty($event, 'phone_no')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">อีเมล</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="9"
                  v-model="employee.email"
                  clearable
                  :rules="[
                    (v) => !v || /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
                  ]"
                  @change="checkEmpty($event, 'email')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div v-if="company.is_ms_entraid">
                <label class="body-2">Microsoft Entra ID (email)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="10"
                  v-model="employee.ms_entraid_email"
                  clearable
                  :rules="[
                    (v) => !v || /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
                  ]"
                  @change="checkEmpty($event, 'ms_entraid_email')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div class="mb-6">
                <label class="body-2">วันเกิด</label>
                <date-picker
                  v-model="employee.birthday"
                  class="mt-1"
                  type="date"
                  format="DD/MM/YYYY"
                  style="width: 100%"
                ></date-picker>
              </div>

              <div>
                <label class="body-2">
                  หน่วยงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="11"
                  v-model="employee.organization_uuid"
                  :items="
                    organizations.map((org) => ({
                      ...org,
                      text: `${org.organization_code} - ${org.title_th}`,
                    }))
                  "
                  :rules="[(v) => !!v || 'โปรดระบุหน่วยงาน']"
                  item-text="text"
                  item-value="organization_uuid"
                  outlined
                  dense
                  @change="handleOrganizationChange($event)"
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  ตำแหน่ง
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="12"
                  v-model="employee.position_uuid"
                  :items="
                    positions
                      .map((pos) => ({
                        ...pos,
                        text: `${pos.position_code} - ${pos.title_th}`,
                      }))
                      .sort((a, b) =>
                        a.position_code.localeCompare(b.position_code)
                      )
                  "
                  :rules="[(v) => !!v || 'โปรดระบุตำแหน่ง']"
                  item-text="text"
                  item-value="position_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  ประเภทพนักงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="13"
                  v-model="employee.employee_type_uuid"
                  :items="
                    employeeTypes
                      .map((empType) => ({
                        ...empType,
                        text: `${empType.employee_type_code} - ${empType.title_th}`,
                      }))
                      .sort((a, b) =>
                        a.employee_type_code.localeCompare(b.employee_type_code)
                      )
                  "
                  :rules="[(v) => !!v || 'โปรดระบุประเภทพนักงาน']"
                  item-text="text"
                  item-value="employee_type_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">ระดับพนักงาน</label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="15"
                  v-model="employee.employee_level_uuid"
                  :items="
                    employeeLevels
                      .map((item) => ({
                        ...item,
                        text: `${item.employee_level_code} - ${item.title_th}`,
                      }))
                      .sort((a, b) =>
                        a.employee_level_code.localeCompare(
                          b.employee_level_code
                        )
                      )
                  "
                  item-text="text"
                  item-value="employee_level_uuid"
                  outlined
                  dense
                  autocomplete="new-password"
                  name="ignore-autofill"
                  id="ignore-autofill"
                >
                </v-autocomplete>
              </div>

              <div v-if="formAction === 'edit'" class="mt-2">
                <p class="mb-0 body-2">รหัสผ่าน</p>
                <v-btn
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable('btn:::employee:password:reset:post')
                  "
                  @click="handleEmployeeResetPassword"
                  class="mt-1"
                >
                  <v-icon left v-if="isResetPassword" color="primary">
                    mdi-autorenew
                  </v-icon>
                  <v-icon left v-else>mdi-key</v-icon>
                  {{
                    isResetPassword ? 'กำลังรีเซ็ตรหัสผ่าน' : 'รีเซ็ตรหัสผ่าน'
                  }}
                </v-btn>
              </div>

              <div v-if="formAction === 'edit'" class="mt-8 mb-6">
                <p class="mb-0 body-2">อัพเดทข้อมูลไปที่ Device</p>
                <v-btn
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable('btn:::employee:password:reset:post')
                  "
                  @click="handleEmployeeLastUpdated"
                  class="mt-1"
                >
                  <v-icon left v-if="isEmployeeLastUpdated" color="primary">
                    mdi-autorenew
                  </v-icon>
                  <v-icon left v-else>mdi-tray-arrow-up</v-icon>
                  {{
                    isEmployeeLastUpdated
                      ? 'กำลังอัพเดทข้อมูล...'
                      : 'อัพเดทข้อมูลพนักงาน'
                  }}
                </v-btn>
              </div>
            </v-tab-item>
            <v-tab-item
              class="px-6 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <div class="mt-2">
                <label class="body-2">Serial Card</label>
                <v-text-field
                  v-model="employee.card.sn"
                  :rules="[
                    (v) =>
                      !v ||
                      /^[0-9A-Za-z]+$/.test(v) ||
                      'ใส่ได้เฉพาะตัวเลขและตัวอักษร',
                    (v) =>
                      !v ||
                      (v && v.length <= 32) ||
                      'หมายเลขบัตรต้องน้อยกว่าหรือเท่ากับ 32 ตัวอักษร',
                  ]"
                  class="fix-google-chrome mt-1"
                  clearable
                  outlined
                  dense
                  :error="!serialValid"
                  :error-messages="serialMessageError"
                  ref="serialInput"
                  @input="handleSerialChange"
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">Pin Code</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="employee.pin_code"
                  :rules="[
                    (v) => !v || /^\d+$/.test(v) || 'ต้องเป็นตัวเลขเท่านั้น',
                    (v) =>
                      !v ||
                      /^\d{4}$/.test(v) ||
                      'Pin Code ต้องเท่ากับ 4 ตัวอักษร',
                  ]"
                  clearable
                  outlined
                  dense
                  autocomplete="new-password"
                  name="ignore-autofill-pin-code"
                  id="ignore-autofill-pin-code"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">วิธีระบุตัวตน</label>
                <v-autocomplete
                  v-model="employee.identify_mode"
                  class="fix-google-chrome mt-1"
                  :items="identifyModes"
                  item-text="title_th"
                  item-value="identify_mode"
                  outlined
                  dense
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable(
                      'select:::identify-mode:hardware:model:update'
                    )
                  "
                >
                </v-autocomplete>
              </div>

              <v-card
                v-for="biometric in biometrics"
                :key="biometric.biometric_code"
                style="cursor: pointer"
                class="mt-1 pa-2 d-flex justify-space-between"
                outlined
                @click="handleOnClickBiometric(biometric)"
              >
                <div class="d-flex">
                  <v-avatar size="40">
                    <img
                      class="biometric-icon"
                      :src="biometric.icon_image_url"
                      alt="image"
                    />
                  </v-avatar>
                  <div class="ml-2">
                    <div>
                      {{ biometric.title_th }}
                    </div>
                    <div style="font-size: 12px">
                      <span
                        :class="
                          biometric.min &&
                          (employeeBiometric.find(
                            (e) => e.biometric_code === biometric.biometric_code
                          )?.biometric_property?.length || 0) >= biometric.min
                            ? 'grey--text'
                            : 'red--text'
                        "
                        >{{
                          employeeBiometric.find(
                            (e) => e.biometric_code === biometric.biometric_code
                          )?.biometric_property?.length || 0
                        }}
                        / {{ biometric.biometric_property.length }}</span
                      >
                      <span> {{ biometric.title_th }}</span>
                    </div>
                  </div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>

              <div class="mt-6">
                <div class="mt-2 mb-6">
                  <label class="body-2 mb-1">วันเริ่มทำงาน</label>
                  <date-picker
                    v-model="employee.time_attendance_start_time"
                    type="datetime"
                    format="DD/MM/YYYY HH:mm"
                    style="width: 100%"
                  ></date-picker>
                </div>
                <div class="mb-6">
                  <label class="body-2 mb-1">วันสิ้นสุดอายุงาน</label>
                  <date-picker
                    v-model="employee.time_attendance_end_time"
                    type="datetime"
                    format="DD/MM/YYYY HH:mm"
                    style="width: 100%"
                  ></date-picker>
                </div>
                <div>
                  <label class="body-2 mr-4">กลุ่มสิทธิ์ (TA & Access)</label>
                  <v-autocomplete
                    v-model="employee.authority"
                    class="fix-google-chrome mt-1"
                    :items="
                      accessAuthorities
                        .map((item) => ({
                          ...item,
                          title_th: `${item.authority_code} - ${item.title_th}`,
                        }))
                        .sort((a, b) =>
                          a.authority_code.localeCompare(b.authority_code)
                        )
                    "
                    :disabled="
                      uiCtrl &&
                      !uiCtrl.isEnable('select:::employee_to_authority:get')
                    "
                    item-text="title_th"
                    item-value="authority_uuid"
                    outlined
                    dense
                    chips
                    small-chips
                    multiple
                  >
                  </v-autocomplete>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item
              class="px-6 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <div class="mt-2">
                <div style="position: relative">
                  <label class="body-2">ผู้อนุมัติลา (หัวหน้าหน่วยงาน)</label>
                  <v-autocomplete
                    class="fix-google-chrome mt-1"
                    tabindex="16"
                    v-model="employee.approval_organization_uuid"
                    :items="
                      organizations.map((org) => ({
                        ...org,
                        text: `${org.organization_code} - ${org.title_th}`,
                      }))
                    "
                    item-text="text"
                    item-value="organization_uuid"
                    outlined
                    dense
                    clearable
                  >
                  </v-autocomplete>
                  <div
                    v-if="employee.approval_organization_uuid"
                    style="position: absolute; bottom: 0"
                  >
                    <span class="caption grey--text">หัวหน้า: </span>
                    <span class="body-2">
                      {{
                        getOrganizationBoss(employee.approval_organization_uuid)
                      }}
                    </span>
                  </div>
                </div>

                <div class="mb-6">
                  <label class="body-2 mb-1">วันที่ผ่านงาน</label>
                  <date-picker
                    v-model="employee.time_attendance.pass_probation_at"
                    type="date"
                    format="DD/MM/YYYY"
                    style="width: 100%"
                  ></date-picker>
                </div>

                <div v-if="formAction === 'edit'" class="mb-6">
                  <label class="body-2">วันที่ลาออก</label>
                  <date-picker
                    v-model="employee.resign_date"
                    class="mt-1"
                    type="date"
                    format="DD/MM/YYYY"
                    style="width: 100%"
                  ></date-picker>
                </div>

                <div>
                  <label class="body-2">
                    กะทำงาน
                    <span class="red--text"><strong>*</strong></span>
                  </label>
                  <v-autocomplete
                    class="fix-google-chrome mt-1"
                    tabindex="14"
                    v-model="employee.shift_uuid"
                    :items="
                      shifts
                        .map((sh) => ({
                          ...sh,
                          text: `${sh.shift_code} - ${sh.title_th}`,
                        }))
                        .sort((a, b) =>
                          a.shift_code.localeCompare(b.shift_code)
                        )
                    "
                    :rules="[(v) => !!v || 'โปรดระบุกะทำงาน']"
                    item-text="text"
                    item-value="shift_uuid"
                    outlined
                    dense
                  >
                  </v-autocomplete>
                </div>

                <div class="mb-2">
                  <label class="body-2 mb-1">วันหยุด</label>
                  <div class="d-flex flex-wrap justify-space-between">
                    <v-checkbox
                      v-model="employee.time_attendance.regular_days_off.monday"
                      dense
                      label="จันทร์"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">จันทร์</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      v-model="
                        employee.time_attendance.regular_days_off.tuesday
                      "
                      dense
                      label="อังคาร"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">อังคาร</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      v-model="
                        employee.time_attendance.regular_days_off.wednesday
                      "
                      dense
                      label="พุธ"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">พุธ</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      v-model="
                        employee.time_attendance.regular_days_off.thursday
                      "
                      dense
                      label="พฤหัสบดี"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">พฤหัสบดี</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      v-model="employee.time_attendance.regular_days_off.friday"
                      dense
                      label="ศุกร์"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">ศุกร์</span>
                      </template>
                    </v-checkbox>
                  </div>
                  <div class="d-flex flex-wrap">
                    <v-checkbox
                      v-model="
                        employee.time_attendance.regular_days_off.saturday
                      "
                      dense
                      label="เสาร์"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">เสาร์</span>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      v-model="employee.time_attendance.regular_days_off.sunday"
                      class="ml-7"
                      dense
                      label="อาทิตย์"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">อาทิตย์</span>
                      </template>
                    </v-checkbox>
                  </div>
                  <div class="mb-6">
                    <v-divider class="my-2"></v-divider>
                    <v-checkbox
                      v-model="employee.time_attendance.is_public_holiday_off"
                      dense
                      label="หยุดตามปฏิทินวันหยุดบริษัท"
                      hide-details
                    >
                      <template v-slot:label>
                        <span class="body-2">หยุดตามปฏิทินวันหยุดบริษัท</span>
                      </template>
                    </v-checkbox>
                  </div>
                </div>

                <div class="mb-6">
                  <label class="body-2 mb-1">เงื่อนไขเพิ่มเติม</label>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th></th>
                          <th class="text-left">มาสาย</th>
                          <th class="text-left">กลับก่อน</th>
                          <th class="text-left">ทำ OT</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>วันทำงาน</td>
                          <td>
                            <v-checkbox
                              v-model="
                                employee.time_attendance.is_workday_late_allowed
                              "
                              dense
                              label="ได้"
                              class="pa-0 my-2"
                              hide-details
                            >
                              <template v-slot:label>
                                <span class="body-2">ได้</span>
                              </template>
                            </v-checkbox>
                          </td>
                          <td>
                            <v-checkbox
                              v-model="
                                employee.time_attendance
                                  .is_workday_early_allowed
                              "
                              dense
                              label="ได้"
                              class="pa-0 my-2"
                              hide-details
                            >
                              <template v-slot:label>
                                <span class="body-2">ได้</span>
                              </template>
                            </v-checkbox>
                          </td>
                          <td>
                            <v-checkbox
                              v-model="
                                employee.time_attendance
                                  .is_workday_overtime_allowed
                              "
                              dense
                              label="ได้"
                              class="pa-0 my-2"
                              hide-details
                            >
                              <template v-slot:label>
                                <span class="body-2">ได้</span>
                              </template>
                            </v-checkbox>
                          </td>
                        </tr>
                        <tr>
                          <td>วันหยุด</td>
                          <td>
                            <v-checkbox
                              v-model="
                                employee.time_attendance.is_day_off_late_allowed
                              "
                              dense
                              label="ได้"
                              class="pa-0 my-2"
                              hide-details
                            >
                              <template v-slot:label>
                                <span class="body-2">ได้</span>
                              </template>
                            </v-checkbox>
                          </td>
                          <td>
                            <v-checkbox
                              v-model="
                                employee.time_attendance
                                  .is_day_off_early_allowed
                              "
                              dense
                              label="ได้"
                              class="pa-0 my-2"
                              hide-details
                            >
                              <template v-slot:label>
                                <span class="body-2">ได้</span>
                              </template>
                            </v-checkbox>
                          </td>
                          <td>
                            <v-checkbox
                              v-model="
                                employee.time_attendance
                                  .is_day_off_overtime_allowed
                              "
                              dense
                              label="ได้"
                              class="pa-0 my-2"
                              hide-details
                            >
                              <template v-slot:label>
                                <span class="body-2">ได้</span>
                              </template>
                            </v-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div class="mt-2 d-flex align-center flex-wrap">
                    <div class="d-flex align-center">
                      <v-checkbox
                        v-model="
                          employee.time_attendance.is_time_attendance_required
                        "
                        dense
                        label="ต้องลงเวลาทำงาน"
                        class="pa-0 my-2"
                        hide-details
                      >
                        <template v-slot:label>
                          <span class="body-2">ต้องลงเวลาทำงาน</span>
                        </template>
                      </v-checkbox>
                    </div>
                    <div class="d-flex align-center ml-8">
                      <v-checkbox
                        v-model="
                          employee.time_attendance.is_shift_allowance_eligible
                        "
                        dense
                        label="ได้รับเงินค่ากะทำงาน"
                        class="pa-0 my-2"
                        hide-details
                      >
                        <template v-slot:label>
                          <span class="body-2">ได้รับเงินค่ากะทำงาน</span>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item
              class="px-4 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <v-card outlined class="px-2 pt-1 pb-3 mb-4">
                <v-checkbox
                  v-model="
                    employee.time_attendance_offsite_grant
                      .is_check_in_out_enabled
                  "
                  dense
                  label="Check-IN/Check-OUT"
                >
                  <template v-slot:label>
                    <span class="body-2">Check-IN/Check-OUT</span>
                  </template>
                </v-checkbox>
                <div class="d-flex">
                  <div class="flex-grow-1 mr-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่เริ่มต้น
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant
                          .check_in_out_start_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledAfterCheckInCheckOutEndAt"
                    ></date-picker>
                  </div>
                  <div class="flex-grow-1 ml-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่สิ้นสุด
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant
                          .check_in_out_end_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledBeforeCheckInCheckOutStartAt"
                    ></date-picker>
                  </div>
                </div>
              </v-card>
              <v-card outlined class="px-2 pt-1 pb-3 mb-4">
                <v-checkbox
                  v-model="
                    employee.time_attendance_offsite_grant.is_anywhere_enabled
                  "
                  dense
                  label="ลงเวลาได้ทุกสถานที่"
                >
                  <template v-slot:label>
                    <span class="body-2">ลงเวลาได้ทุกสถานที่</span>
                  </template>
                </v-checkbox>
                <div class="d-flex">
                  <div class="flex-grow-1 mr-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่เริ่มต้น
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant.anywhere_start_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledAfterAnywhereEndAt"
                    ></date-picker>
                  </div>
                  <div class="flex-grow-1 ml-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่สิ้นสุด
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant.anywhere_end_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledBeforeAnywhereStartAt"
                    ></date-picker>
                  </div>
                </div>
              </v-card>
              <v-card outlined class="px-2 pt-1 pb-3 mb-4">
                <v-checkbox
                  v-model="
                    employee.time_attendance_offsite_grant.is_company_enabled
                  "
                  class="mt-0"
                  dense
                  label="ลงเวลาที่บริษัทและสาขา"
                  hide-details
                >
                  <template v-slot:label>
                    <span class="body-2">ลงเวลาที่บริษัทและสาขา</span>
                  </template>
                </v-checkbox>
                <div class="mt-3 ml-1 d-flex align-center">
                  <label
                    class="d-flex align-center mr-6"
                    style="cursor: pointer"
                  >
                    <input
                      :checked="
                        employee.time_attendance_offsite_grant
                          .is_company_location_apply_all === false
                      "
                      type="radio"
                      name="company-location-mode"
                      @change="handleCompanyLocationModeChange(true)"
                    />
                    <span class="body-2 ml-2">ระบุสถานที่</span>
                  </label>
                  <label class="d-flex align-center" style="cursor: pointer">
                    <input
                      :checked="
                        employee.time_attendance_offsite_grant
                          .is_company_location_apply_all === true
                      "
                      type="radio"
                      name="company-location-mode"
                      @change="handleCompanyLocationModeChange(false)"
                    />
                    <span class="body-2 ml-2">ทุกสถานที่บริษัทและสาขา</span>
                  </label>
                </div>
                <div
                  v-if="
                    employee.time_attendance_offsite_grant
                      .is_company_location_apply_all === false
                  "
                  class="mt-2 d-flex align-center"
                >
                  <div
                    v-if="getCompanyLocations().length > 0"
                    class="d-flex align-center"
                    style="overflow-x: auto; white-space: nowrap"
                  >
                    <v-chip
                      v-for="item in getCompanyLocationsPreview()"
                      :key="item.wfh_location_uuid || item.title_th"
                      class="mr-2"
                      outlined
                    >
                      {{ item.title_th || '-' }}
                    </v-chip>
                  </div>
                  <v-btn
                    @click="handleOpenCompanyLocationDialog"
                    :icon="getCompanyLocationOverflowCount() === 0"
                    :outlined="getCompanyLocationOverflowCount() > 0"
                    :rounded="getCompanyLocationOverflowCount() > 0"
                    small
                    color="primary"
                  >
                    <template v-if="getCompanyLocationOverflowCount() > 0">
                      +{{ getCompanyLocationOverflowCount() }}
                    </template>
                    <template v-else>
                      <v-icon small>mdi-plus</v-icon>
                    </template>
                  </v-btn>
                </div>
                <div
                  v-if="
                    employee.time_attendance_offsite_grant
                      .is_company_location_apply_all === true
                  "
                  class="d-flex mt-3"
                >
                  <div class="flex-grow-1 mr-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่เริ่มต้น
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant.company_start_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledAfterCompanyEndAt"
                    ></date-picker>
                  </div>
                  <div class="flex-grow-1 ml-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่สิ้นสุด
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant.company_end_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledBeforeCompanyStartAt"
                    ></date-picker>
                  </div>
                </div>
              </v-card>
              <v-card outlined class="px-2 pt-1 pb-3 mb-4">
                <v-checkbox
                  v-model="
                    employee.time_attendance_offsite_grant
                      .is_client_site_enabled
                  "
                  class="mt-0"
                  dense
                  label="ลงเวลาที่บริษัทลูกค้า"
                  hide-details
                >
                  <template v-slot:label>
                    <span class="body-2">ลงเวลาที่บริษัทลูกค้า</span>
                  </template>
                </v-checkbox>
                <div class="mt-3 ml-1 d-flex align-center">
                  <label
                    class="d-flex align-center mr-6"
                    style="cursor: pointer"
                  >
                    <input
                      :checked="
                        employee.time_attendance_offsite_grant
                          .is_client_site_apply_all === false
                      "
                      type="radio"
                      name="client-site-location-mode"
                      @change="handleClientSiteLocationModeChange(true)"
                    />
                    <span class="body-2 ml-2">ระบุสถานที่</span>
                  </label>
                  <label class="d-flex align-center" style="cursor: pointer">
                    <input
                      :checked="
                        employee.time_attendance_offsite_grant
                          .is_client_site_apply_all === true
                      "
                      type="radio"
                      name="client-site-location-mode"
                      @change="handleClientSiteLocationModeChange(false)"
                    />
                    <span class="body-2 ml-2">ทุกสถานที่บริษัทลูกค้า</span>
                  </label>
                </div>
                <div
                  v-if="
                    employee.time_attendance_offsite_grant
                      .is_client_site_apply_all === false
                  "
                  class="mt-2 d-flex align-center"
                >
                  <div
                    v-if="getClientSiteLocations().length > 0"
                    class="d-flex align-center"
                    style="overflow-x: auto; white-space: nowrap"
                  >
                    <v-chip
                      v-for="item in getClientSiteLocationsPreview()"
                      :key="item.wfh_location_uuid || item.title_th"
                      class="mr-2"
                      outlined
                    >
                      {{ item.title_th || '-' }}
                    </v-chip>
                  </div>
                  <v-btn
                    @click="handleOpenClientSiteLocationDialog"
                    :icon="getClientSiteLocationOverflowCount() === 0"
                    :outlined="getClientSiteLocationOverflowCount() > 0"
                    :rounded="getClientSiteLocationOverflowCount() > 0"
                    small
                    color="primary"
                  >
                    <template v-if="getClientSiteLocationOverflowCount() > 0">
                      +{{ getClientSiteLocationOverflowCount() }}
                    </template>
                    <template v-else>
                      <v-icon small>mdi-plus</v-icon>
                    </template>
                  </v-btn>
                </div>
                <!-- <div class="d-flex"> ... </div> -->
                <div
                  v-if="
                    employee.time_attendance_offsite_grant
                      .is_client_site_apply_all === true
                  "
                  class="d-flex mt-3"
                >
                  <div class="flex-grow-1 mr-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่เริ่มต้น
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant
                          .client_site_start_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledAfterClientSiteEndAt"
                    ></date-picker>
                  </div>
                  <div class="flex-grow-1 ml-2">
                    <div style="color: #555; font-size: 12px; margin-left: 5px">
                      วันที่สิ้นสุด
                    </div>
                    <date-picker
                      v-model="
                        employee.time_attendance_offsite_grant
                          .client_site_end_at
                      "
                      type="date"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      :clearable="true"
                      :disabled-date="disabledBeforeClientSiteStartAt"
                    ></date-picker>
                  </div>
                </div>
              </v-card>
              <v-card outlined class="px-2 pt-1 pb-3 mb-4">
                <v-checkbox
                  v-model="
                    employee.time_attendance_offsite_grant.is_wfh_enabled
                  "
                  class="mb-3"
                  dense
                  label="ลงเวลาที่บ้าน"
                  hide-details
                >
                  <template v-slot:label>
                    <span class="body-2">ลงเวลาที่บ้าน</span>
                  </template>
                </v-checkbox>
                <div class="mt-2 d-flex align-center">
                  <div
                    v-if="getActiveWfhLocations().length > 0"
                    class="d-flex align-center"
                    style="overflow-x: auto; white-space: nowrap"
                  >
                    <v-chip
                      v-for="(item, index) in getWfhLocationsPreview()"
                      :key="item.wfh_location_uuid || `wfh-${index}`"
                      class="mr-2"
                      outlined
                    >
                      {{ item.title_th || '-' }}
                    </v-chip>
                  </div>
                  <v-btn
                    @click="handleOpenWfhLocationDialog"
                    :icon="getWfhLocationOverflowCount() === 0"
                    :outlined="getWfhLocationOverflowCount() > 0"
                    :rounded="getWfhLocationOverflowCount() > 0"
                    small
                    color="primary"
                  >
                    <template v-if="getWfhLocationOverflowCount() > 0">
                      +{{ getWfhLocationOverflowCount() }}
                    </template>
                    <template v-else>
                      <v-icon small>mdi-plus</v-icon>
                    </template>
                  </v-btn>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isEmployeeDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:create')"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:update')"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogWfhLocationList" persistent max-width="900">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>สถานที่ลงเวลาที่บ้าน</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogWfhLocationList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center mb-3">
            <v-text-field
              v-model="wfhLocationSearch"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              style="max-width: 260px"
            ></v-text-field>
            <v-btn
              class="ml-2"
              @click="handleAddWfhLocation"
              depressed
              color="primary"
              >เพิ่มสถานที่</v-btn
            >
            <v-btn
              v-if="(employee.wfh_locations || []).length > 0"
              class="ml-2"
              outlined
              color="error"
              @click="onDeleteAllWfhLocations"
            >
              ลบทั้งหมด
            </v-btn>
          </div>
          <v-data-table
            :headers="wfhLocationHeaders"
            :items="employee.wfh_locations || []"
            :search="wfhLocationSearch"
            :page.sync="wfhLocationPage"
            :items-per-page="wfhLocationItemsPerPage"
            item-key="wfh_location_uuid"
            class="elevation-1"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 25, 50],
              itemsPerPageText: 'Rows per page:',
            }"
            no-data-text="ยังไม่มีสถานที่"
          >
            <template v-slot:item.index="{ index }">
              <span class="body-2">
                {{
                  getTableRowIndex(
                    index,
                    wfhLocationPage,
                    wfhLocationItemsPerPage
                  )
                }}
              </span>
            </template>
            <template v-slot:item.title_th="{ item }">
              <span class="body-2">{{ item.title_th || '-' }}</span>
            </template>
            <template v-slot:item.latitude="{ item }">
              <span class="body-2">{{ formatCoordinate(item.latitude) }}</span>
            </template>
            <template v-slot:item.longitude="{ item }">
              <span class="body-2">
                {{ formatCoordinate(item.longitude) }}
              </span>
            </template>
            <template v-slot:item.radius_meter="{ item }">
              <span class="body-2">{{ item.radius_meter || 0 }}</span>
            </template>
            <template v-slot:item.wfh_usage_date="{ item }">
              <div class="d-flex align-center">
                <v-chip
                  v-if="hasWfhLocationSchedules(item)"
                  outlined
                  class="mr-1 mb-1"
                  @click="handleOpenWfhLocationSchedules(item)"
                >
                  {{ getWfhLocationFirstScheduleLabel(item) }}
                </v-chip>
                <v-btn
                  class="mb-1"
                  outlined
                  small
                  color="primary"
                  @click="handleOpenWfhLocationSchedules(item)"
                >
                  {{ getWfhLocationScheduleButtonLabel(item) }}
                </v-btn>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="text-right">
                <v-btn icon small @click="handleEditWfhLocation(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small @click="onDeleteWfhLocation(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddWfhLocation" persistent max-width="480">
      <v-card>
        <v-card-title class="text-h5">
          {{
            wfhLocation.wfh_location_type_action === 'edit'
              ? 'แก้ไขสถานที่ลงเวลาทำงานที่บ้าน'
              : 'เพิ่มสถานที่ลงเวลาทำงานที่บ้าน'
          }}
        </v-card-title>
        <v-card-text>
          <v-form ref="formWfhLocation" lazy-validation>
            <label class="body-2">
              ชื่อสถานที่
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              v-model="wfhLocation.title_th"
              :rules="[(v) => !!v || 'โปรดระบุชื่อสถานที่']"
              required
              clearable
              @change="checkWfhLocationEmpty($event, 'title_th')"
              outlined
              dense
            >
            </v-text-field>
            <label class="body-2">สถานที่ (อังกฤษ)</label>
            <v-text-field
              class="fix-google-chrome mt-1"
              v-model="wfhLocation.title_en"
              clearable
              @change="checkWfhLocationEmpty($event, 'title_en')"
              outlined
              dense
            ></v-text-field>
            <div class="d-flex align-center">
              <div class="flex-grow-1 mr-2">
                <label class="body-2">
                  ละติจูด
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="wfhLocation.latitude"
                  :rules="[
                    (v) => !!v || 'โปรดระบุละติจูด',
                    (v) =>
                      /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ละติจูดต้องเป็นตัวเลข',
                    (v) =>
                      (v >= -90 && v <= 90) ||
                      'ละติจูดต้องอยู่ระหว่าง -90 ถึง 90',
                  ]"
                  required
                  clearable
                  @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
                  @change="checkWfhLocationEmpty($event, 'latitude')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>
              <div class="flex-grow-1 mr-2">
                <label class="body-2">
                  ลองจิจูด
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="wfhLocation.longitude"
                  :rules="[
                    (v) => !!v || 'โปรดระบุลองจิจูด',
                    (v) =>
                      /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ลองจิจูดต้องเป็นตัวเลข',
                    (v) =>
                      (v >= -180 && v <= 180) ||
                      'ลองจิจูดต้องอยู่ระหว่าง -180 ถึง 180',
                  ]"
                  required
                  clearable
                  @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
                  @change="checkWfhLocationEmpty($event, 'longitude')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>
              <div>
                <a
                  v-if="appMode === 'private'"
                  :href="googleMapsUrl"
                  target="_blank"
                >
                  Google Maps
                </a>
                <v-btn
                  v-else
                  icon
                  color="error"
                  @click="onOpenLocationGoogleMapDialog"
                >
                  <v-icon>mdi-map-marker</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="mt-4">
              <label class="body-2">
                รัศมี (เมตร)
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="wfhLocation.radius_meter"
                :rules="[
                  (v) => !!v || 'โปรดระบุรัศมี (เมตร)',
                  (v) => /^\d+$/.test(v) || 'รัศมีต้องเป็นตัวเลขจำนวนเต็ม',
                ]"
                required
                clearable
                @change="checkWfhLocationEmpty($event, 'radius_meter')"
                outlined
                dense
              >
              </v-text-field>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary mr-1"
            depressed
            @click="handleSubmitWfhLocation"
          >
            ตกลง
          </v-btn>
          <v-btn depressed @click="handleCancelWfhLocation">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogWfhLocationDateRange" scrollable max-width="480">
      <v-card class="pb-10">
        <v-card-title class="text-h5 d-flex align-center">
          <span>ระบุวันที่ใช้งานสถานที่</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="handleCancelWfhLocationDateRange">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn
            class="mr-2"
            small
            color="primary"
            depressed
            @click="handleOpenAddWfhLocationScheduleDialog"
          >
            เพิ่มวันที่
          </v-btn>
          <v-btn
            small
            color="error"
            outlined
            v-if="
              pendingWfhLocation &&
              getWfhLocationSchedules(pendingWfhLocation).length > 0
            "
            @click="onDeleteAllWfhLocationSchedules"
          >
            ลบทั้งหมด
          </v-btn>
        </v-card-text>
        <v-card-text style="height: 300px; border: 1px solid #eee" class="pb-0">
          <div
            v-if="
              pendingWfhLocation &&
              getWfhLocationSchedules(pendingWfhLocation).length > 0
            "
          >
            <v-list dense class="pa-0">
              <v-list-item
                v-for="(schedule, idx) in getWfhLocationSchedules(
                  pendingWfhLocation
                )"
                :key="schedule.wfh_location_schedule_uuid || idx"
                class="px-0"
              >
                <v-list-item-content>
                  <span class="body-2">
                    {{
                      formatWfhLocationScheduleLabel(
                        schedule,
                        pendingWfhLocation ? pendingWfhLocation.timezone : null
                      )
                    }}
                  </span>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    icon
                    small
                    @click="onDeleteWfhLocationSchedule(schedule, idx)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-else class="grey--text text--darken-1 body-2 py-4 text-center">
            ยังไม่มีวันที่ที่กำหนด
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddWfhLocationSchedule" max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>เพิ่มวันที่ใช้งานสถานที่</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAddWfhLocationSchedule = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <div class="flex-grow-1 mr-2">
              <div style="color: #555; font-size: 12px; margin-left: 5px">
                วันที่เริ่มต้น
              </div>
              <date-picker
                v-model="wfhLocationScheduleDateRange.start_at"
                type="date"
                format="DD/MM/YYYY"
                style="width: 100%"
                :clearable="true"
                :disabled-date="disabledAfterSelectedWfhScheduleEndAt"
              ></date-picker>
            </div>
            <div class="flex-grow-1 ml-2">
              <div style="color: #555; font-size: 12px; margin-left: 5px">
                วันที่สิ้นสุด
              </div>
              <date-picker
                v-model="wfhLocationScheduleDateRange.end_at"
                type="date"
                format="DD/MM/YYYY"
                style="width: 100%"
                :clearable="true"
                :disabled-date="disabledBeforeSelectedWfhScheduleStartAt"
              ></date-picker>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            @click="handleConfirmWfhLocationSchedule"
          >
            ตกลง
          </v-btn>
          <v-btn depressed @click="dialogAddWfhLocationSchedule = false"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCompanyLocationList" persistent max-width="900">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>สถานที่ลงเวลาที่บริษัทและสาขา</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCompanyLocationList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center mb-3">
            <v-text-field
              v-model="companyLocationSearch"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              style="max-width: 260px"
            ></v-text-field>
            <v-btn
              class="ml-2"
              depressed
              color="primary"
              @click="handleOpenAddCompanyLocationDialog"
            >
              เพิ่มสถานที่
            </v-btn>
            <v-btn
              v-if="getCompanyLocations().length > 0"
              class="ml-2"
              outlined
              color="error"
              @click="onDeleteAllCompanyLocations"
            >
              ลบทั้งหมด
            </v-btn>
          </div>
          <v-data-table
            :headers="companyLocationModeHeaders"
            :items="getCompanyLocations()"
            :search="companyLocationSearch"
            :page.sync="companyLocationPage"
            :items-per-page="companyLocationItemsPerPage"
            class="elevation-1"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 25, 50],
              itemsPerPageText: 'Rows per page:',
            }"
            no-data-text="ยังไม่มีสถานที่"
          >
            <template v-slot:item.index="{ index }">
              <span class="body-2">
                {{
                  getTableRowIndex(
                    index,
                    companyLocationPage,
                    companyLocationItemsPerPage
                  )
                }}
              </span>
            </template>
            <template v-slot:item.title_th="{ item }">
              <span class="body-2">{{ item.title_th || '-' }}</span>
            </template>
            <template v-slot:item.latitude="{ item }">
              <span class="body-2">{{ formatCoordinate(item.latitude) }}</span>
            </template>
            <template v-slot:item.longitude="{ item }">
              <span class="body-2">{{ formatCoordinate(item.longitude) }}</span>
            </template>
            <template v-slot:item.radius_meter="{ item }">
              <span class="body-2">{{ item.radius_meter || 0 }}</span>
            </template>
            <template v-slot:item.company_usage_date="{ item }">
              <div class="d-flex align-center">
                <v-chip
                  v-if="hasCompanyLocationSchedules(item)"
                  outlined
                  class="mr-1 mb-1"
                  @click="handleOpenLocationSchedules(item)"
                >
                  {{ getCompanyLocationFirstScheduleLabel(item) }}
                </v-chip>
                <v-btn
                  class="mb-1"
                  outlined
                  small
                  color="primary"
                  @click="handleOpenLocationSchedules(item)"
                >
                  {{ getCompanyLocationScheduleButtonLabel(item) }}
                </v-btn>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="text-right">
                <v-btn icon small @click="onDeleteCompanyLocation(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddCompanyLocation" max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>เลือกสถานที่บริษัทและสาขา</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAddCompanyLocation = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="companyLocationSelectorSearch"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            dense
            hide-details
            class="mb-3"
          ></v-text-field>
          <div
            :style="{
              height: '360px',
              overflowY: 'auto',
            }"
          >
            <div
              v-if="companyLocationLoading"
              class="pa-4 text-center grey--text text--darken-1"
            >
              กำลังโหลดข้อมูลสถานที่
            </div>
            <v-list v-else-if="filteredCompanyLocations.length > 0" dense>
              <v-list-item
                v-for="item in filteredCompanyLocations"
                :key="item.company_location_uuid || item.wfh_location_uuid"
                @click="handleSelectCompanyLocation(item)"
              >
                <v-list-item-action>
                  <v-checkbox
                    :input-value="
                      selectedCompanyLocationUuids.includes(
                        item.company_location_uuid || item.wfh_location_uuid
                      )
                    "
                    hide-details
                    class="ma-0 pa-0"
                    @click.stop="handleSelectCompanyLocation(item)"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    {{ item.title_th || '-' }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    ละติจูด {{ formatCoordinate(item.latitude) }} | ลองจิจูด
                    {{ formatCoordinate(item.longitude) }} | รัศมี
                    {{ item.radius_meter || 0 }} เมตร
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div v-else class="pa-4 text-center grey--text text--darken-1">
              ยังไม่มีสถานที่
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            :disabled="selectedCompanyLocationUuids.length === 0"
            @click="handleSubmitSelectedCompanyLocation"
          >
            ตกลง
          </v-btn>
          <v-btn depressed @click="dialogAddCompanyLocation = false"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCompanyLocationDateRange"
      scrollable
      max-width="480"
    >
      <v-card class="pb-10">
        <v-card-title class="text-h5 d-flex align-center">
          <span>ระบุวันที่ใช้งานสถานที่</span>

          <v-spacer></v-spacer>
          <v-btn icon @click="handleCancelCompanyLocationDateRange">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn
            class="mr-2"
            small
            color="primary"
            depressed
            @click="handleOpenAddCompanyLocationScheduleDialog"
          >
            เพิ่มวันที่
          </v-btn>
          <v-btn
            small
            color="error"
            outlined
            v-if="
              pendingCompanyLocation &&
              getCompanyLocationSchedules(pendingCompanyLocation).length > 0
            "
            @click="onDeleteAllCompanyLocationSchedules"
          >
            ลบทั้งหมด
          </v-btn>
        </v-card-text>
        <v-card-text style="height: 300px; border: 1px solid #eee" class="pb-0">
          <div
            v-if="
              pendingCompanyLocation &&
              getCompanyLocationSchedules(pendingCompanyLocation).length > 0
            "
          >
            <v-list dense class="pa-0">
              <v-list-item
                v-for="(schedule, idx) in getCompanyLocationSchedules(
                  pendingCompanyLocation
                )"
                :key="
                  schedule.offsite_grant_company_location_schedule_uuid || idx
                "
                class="px-0"
              >
                <v-list-item-content>
                  <span class="body-2">
                    {{
                      formatCompanyLocationScheduleLabel(
                        schedule,
                        pendingCompanyLocation
                          ? pendingCompanyLocation.timezone
                          : null
                      )
                    }}
                  </span>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    icon
                    small
                    @click="onDeleteCompanyLocationSchedule(schedule, idx)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-else class="grey--text text--darken-1 body-2 py-4 text-center">
            ยังไม่มีวันที่ที่กำหนด
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddCompanyLocationSchedule" max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>เพิ่มวันที่ใช้งานสถานที่</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAddCompanyLocationSchedule = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <div class="flex-grow-1 mr-2">
              <div style="color: #555; font-size: 12px; margin-left: 5px">
                วันที่เริ่มต้น
              </div>
              <date-picker
                v-model="companyLocationDateRange.start_at"
                type="date"
                format="DD/MM/YYYY"
                style="width: 100%"
                :clearable="true"
                :disabled-date="disabledAfterSelectedCompanyEndAt"
              ></date-picker>
            </div>
            <div class="flex-grow-1 ml-2">
              <div style="color: #555; font-size: 12px; margin-left: 5px">
                วันที่สิ้นสุด
              </div>
              <date-picker
                v-model="companyLocationDateRange.end_at"
                type="date"
                format="DD/MM/YYYY"
                style="width: 100%"
                :clearable="true"
                :disabled-date="disabledBeforeSelectedCompanyStartAt"
              ></date-picker>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            @click="handleConfirmCompanyLocationDateRange"
          >
            ตกลง
          </v-btn>
          <v-btn depressed @click="dialogAddCompanyLocationSchedule = false"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogClientSiteLocationList" max-width="900">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>สถานที่ลงเวลาที่บริษัทลูกค้า</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogClientSiteLocationList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center mb-3">
            <v-text-field
              v-model="clientSiteLocationSearch"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              style="max-width: 260px"
            ></v-text-field>
            <v-btn
              class="ml-2"
              depressed
              color="primary"
              @click="handleOpenAddClientSiteLocationDialog"
            >
              เพิ่มสถานที่
            </v-btn>
            <v-btn
              v-if="getClientSiteLocations().length > 0"
              class="ml-2"
              outlined
              color="error"
              @click="onDeleteAllClientSiteLocations"
            >
              ลบทั้งหมด
            </v-btn>
          </div>
          <v-data-table
            :headers="clientSiteLocationModeHeaders"
            :items="getClientSiteLocations()"
            :search="clientSiteLocationSearch"
            :page.sync="clientSiteLocationPage"
            :items-per-page="clientSiteLocationItemsPerPage"
            class="elevation-1"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 25, 50],
              itemsPerPageText: 'Rows per page:',
            }"
            no-data-text="ยังไม่มีสถานที่"
          >
            <template v-slot:item.index="{ index }">
              <span class="body-2">
                {{
                  getTableRowIndex(
                    index,
                    clientSiteLocationPage,
                    clientSiteLocationItemsPerPage
                  )
                }}
              </span>
            </template>
            <template v-slot:item.title_th="{ item }">
              <span class="body-2">{{ item.title_th || '-' }}</span>
            </template>
            <template v-slot:item.latitude="{ item }">
              <span class="body-2">{{ formatCoordinate(item.latitude) }}</span>
            </template>
            <template v-slot:item.longitude="{ item }">
              <span class="body-2">{{ formatCoordinate(item.longitude) }}</span>
            </template>
            <template v-slot:item.radius_meter="{ item }">
              <span class="body-2">{{ item.radius_meter || 0 }}</span>
            </template>
            <template v-slot:item.client_usage_date="{ item }">
              <div class="d-flex align-center">
                <v-chip
                  v-if="hasClientSiteLocationSchedules(item)"
                  outlined
                  class="mr-1 mb-1"
                  @click="handleOpenClientSiteLocationSchedules(item)"
                >
                  {{ getClientSiteLocationFirstScheduleLabel(item) }}
                </v-chip>
                <v-btn
                  class="mb-1"
                  outlined
                  small
                  color="primary"
                  @click="handleOpenClientSiteLocationSchedules(item)"
                >
                  {{ getClientSiteLocationScheduleButtonLabel(item) }}
                </v-btn>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="text-right">
                <v-btn icon small @click="onDeleteClientSiteLocation(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddClientSiteLocation" max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>เลือกสถานที่บริษัทลูกค้า</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAddClientSiteLocation = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="clientSiteLocationSelectorSearch"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            dense
            hide-details
            class="mb-3"
          ></v-text-field>
          <div
            :style="{
              height: '360px',
              overflowY: 'auto',
            }"
          >
            <div
              v-if="clientSiteLocationLoading"
              class="pa-4 text-center grey--text text--darken-1"
            >
              กำลังโหลดข้อมูลสถานที่
            </div>
            <v-list v-else-if="filteredClientSiteLocations.length > 0" dense>
              <v-list-item
                v-for="item in filteredClientSiteLocations"
                :key="item.client_site_location_uuid || item.wfh_location_uuid"
                @click="handleSelectClientSiteLocation(item)"
              >
                <v-list-item-action>
                  <v-checkbox
                    :input-value="
                      selectedClientSiteLocationUuids.includes(
                        item.client_site_location_uuid || item.wfh_location_uuid
                      )
                    "
                    hide-details
                    class="ma-0 pa-0"
                    @click.stop="handleSelectClientSiteLocation(item)"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    {{ item.title_th || '-' }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    ละติจูด {{ formatCoordinate(item.latitude) }} | ลองจิจูด
                    {{ formatCoordinate(item.longitude) }} | รัศมี
                    {{ item.radius_meter || 0 }} เมตร
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div v-else class="pa-4 text-center grey--text text--darken-1">
              ยังไม่มีสถานที่
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            :disabled="selectedClientSiteLocationUuids.length === 0"
            @click="handleSubmitSelectedClientSiteLocation"
          >
            ตกลง
          </v-btn>
          <v-btn depressed @click="dialogAddClientSiteLocation = false"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogClientSiteLocationDateRange"
      scrollable
      max-width="480"
    >
      <v-card class="pb-10">
        <v-card-title class="text-h5 d-flex align-center">
          <span>ระบุวันที่ใช้งานสถานที่</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="handleCancelClientSiteLocationDateRange">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn
            class="mr-2"
            small
            color="primary"
            depressed
            @click="handleOpenAddClientSiteLocationScheduleDialog"
          >
            เพิ่มวันที่
          </v-btn>
          <v-btn
            small
            color="error"
            outlined
            v-if="
              pendingClientSiteLocation &&
              getClientSiteLocationSchedules(pendingClientSiteLocation).length >
                0
            "
            @click="onDeleteAllClientSiteLocationSchedules"
          >
            ลบทั้งหมด
          </v-btn>
        </v-card-text>
        <v-card-text style="height: 300px; border: 1px solid #eee" class="pb-0">
          <div
            v-if="
              pendingClientSiteLocation &&
              getClientSiteLocationSchedules(pendingClientSiteLocation).length >
                0
            "
          >
            <v-list dense class="pa-0">
              <v-list-item
                v-for="(schedule, idx) in getClientSiteLocationSchedules(
                  pendingClientSiteLocation
                )"
                :key="
                  schedule.offsite_grant_client_site_location_schedule_uuid ||
                  idx
                "
                class="px-0"
              >
                <v-list-item-content>
                  <span class="body-2">
                    {{
                      formatClientSiteLocationScheduleLabel(
                        schedule,
                        pendingClientSiteLocation
                          ? pendingClientSiteLocation.timezone
                          : null
                      )
                    }}
                  </span>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    icon
                    small
                    @click="onDeleteClientSiteLocationSchedule(schedule, idx)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-else class="grey--text text--darken-1 body-2 py-4 text-center">
            ยังไม่มีวันที่ที่กำหนด
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddClientSiteLocationSchedule" max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <span>เพิ่มวันที่ใช้งานสถานที่</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAddClientSiteLocationSchedule = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <div class="flex-grow-1 mr-2">
              <div style="color: #555; font-size: 12px; margin-left: 5px">
                วันที่เริ่มต้น
              </div>
              <date-picker
                v-model="clientSiteLocationDateRange.start_at"
                type="date"
                format="DD/MM/YYYY"
                style="width: 100%"
                :clearable="true"
                :disabled-date="disabledAfterSelectedClientSiteEndAt"
              ></date-picker>
            </div>
            <div class="flex-grow-1 ml-2">
              <div style="color: #555; font-size: 12px; margin-left: 5px">
                วันที่สิ้นสุด
              </div>
              <date-picker
                v-model="clientSiteLocationDateRange.end_at"
                type="date"
                format="DD/MM/YYYY"
                style="width: 100%"
                :clearable="true"
                :disabled-date="disabledBeforeSelectedClientSiteStartAt"
              ></date-picker>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            @click="handleConfirmClientSiteLocationDateRange"
          >
            ตกลง
          </v-btn>
          <v-btn depressed @click="dialogAddClientSiteLocationSchedule = false"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogResetPassword"
      :dialogData="confirmDialogDataResetPassword"
      @cancelConfirmDialog="cancelConfirmDialogResetPassword"
      @submitConfirmDialog="submitConfirmDialogResetPassword"
    />
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteEmployeePhotoIdentifier"
      :loading="confirmDialogDeleteEmployeePhotoIdentifierLoading"
      :dialogData="confirmDialogDeleteEmployeePhotoIdentifierData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteEmployeePhotoIdentifier"
      @submitConfirmDialog="submitConfirmDialogDeleteEmployeePhotoIdentifier"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteWfhLocation"
      :loading="confirmDialogDeleteWfhLocationLoading"
      :dialogData="confirmDialogDeleteWfhLocationData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteWfhLocation"
      @submitConfirmDialog="submitConfirmDialogDeleteWfhLocation"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteWfhLocationSchedule"
      :loading="confirmDialogDeleteWfhLocationScheduleLoading"
      :dialogData="confirmDialogDeleteWfhLocationScheduleData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteWfhLocationSchedule"
      @submitConfirmDialog="submitConfirmDialogDeleteWfhLocationSchedule"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteCompanyLocationSchedule"
      :loading="confirmDialogDeleteCompanyLocationScheduleLoading"
      :dialogData="confirmDialogDeleteCompanyLocationScheduleData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteCompanyLocationSchedule"
      @submitConfirmDialog="submitConfirmDialogDeleteCompanyLocationSchedule"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteClientSiteLocationSchedule"
      :loading="confirmDialogDeleteClientSiteLocationScheduleLoading"
      :dialogData="confirmDialogDeleteClientSiteLocationScheduleData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteClientSiteLocationSchedule"
      @submitConfirmDialog="submitConfirmDialogDeleteClientSiteLocationSchedule"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteCompanyLocation"
      :loading="confirmDialogDeleteCompanyLocationLoading"
      :dialogData="confirmDialogDeleteCompanyLocationData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteCompanyLocation"
      @submitConfirmDialog="submitConfirmDialogDeleteCompanyLocation"
    />
    <GoogleMap
      :dialog="googleMapDialog"
      @onSubmit="onSubmitLocationGoogleMapDialog"
      @onCancel="onCancelLocationGoogleMapDialog"
    />
  </v-navigation-drawer>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
// import axios from 'axios'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import GoogleMap from '@/components/GoogleMap.vue'
import _ from 'lodash'
import moment from 'moment'
import tzlookup from 'tz-lookup'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapActions } from 'vuex'

// import static data
import timezone from '@/data/timezone.json'

export default {
  name: 'EmployeeForm',
  components: { ConfirmDialog, DatePicker, GoogleMap },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    employee: {
      type: Object,
    },
    employeeInit: {
      type: Object,
    },
    setTab: {
      type: Number,
    },
  },
  data() {
    return {
      showPassword: false,
      serialValid: true,
      serialMessageError: '',
      tabs: 0,
      fileImage: null,
      uploadFilePreview: null,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      isResetPassword: false,
      isEmployeeLastUpdated: false,
      confirmDialogResetPassword: false,
      confirmDialogDataResetPassword: {},
      confirmDialogDeleteEmployeePhotoIdentifier: false,
      confirmDialogDeleteEmployeePhotoIdentifierLoading: false,
      confirmDialogDeleteEmployeePhotoIdentifierData: {},
      confirmDialogDeleteWfhLocation: false,
      confirmDialogDeleteWfhLocationLoading: false,
      confirmDialogDeleteWfhLocationData: {},
      confirmDialogDeleteWfhLocationSchedule: false,
      confirmDialogDeleteWfhLocationScheduleLoading: false,
      confirmDialogDeleteWfhLocationScheduleData: {},
      confirmDialogDeleteCompanyLocation: false,
      confirmDialogDeleteCompanyLocationLoading: false,
      confirmDialogDeleteCompanyLocationData: {},
      confirmDialogDeleteCompanyLocationSchedule: false,
      confirmDialogDeleteCompanyLocationScheduleLoading: false,
      confirmDialogDeleteCompanyLocationScheduleData: {},
      confirmDialogDeleteClientSiteLocationSchedule: false,
      confirmDialogDeleteClientSiteLocationScheduleLoading: false,
      confirmDialogDeleteClientSiteLocationScheduleData: {},
      wfhLocation: {},
      wfhLocationInit: {},
      dialogWfhLocationList: false,
      dialogAddWfhLocation: false,
      dialogWfhLocationDateRange: false,
      dialogAddWfhLocationSchedule: false,
      dialogCompanyLocationList: false,
      dialogAddCompanyLocation: false,
      dialogCompanyLocationDateRange: false,
      dialogAddCompanyLocationSchedule: false,
      dialogClientSiteLocationList: false,
      dialogAddClientSiteLocation: false,
      dialogClientSiteLocationDateRange: false,
      dialogAddClientSiteLocationSchedule: false,
      googleMapsUrl: 'https://maps.google.com',
      appMode: process.env.VUE_APP_MODE,
      googleMapDialog: false,
      timezone: timezone,
      wfhLocationSearch: '',
      companyLocationSearch: '',
      companyLocationSelectorSearch: '',
      clientSiteLocationSearch: '',
      clientSiteLocationSelectorSearch: '',
      companyLocationLoading: false,
      clientSiteLocationLoading: false,
      isCompanyLocationFetched: false,
      isClientSiteLocationFetched: false,
      companyOffsiteLocationsLoading: false,
      companyOffsiteLocationsFetchedKey: '',
      clientOffsiteLocationsLoading: false,
      clientOffsiteLocationsFetchedKey: '',
      selectedCompanyLocationUuids: [],
      selectedClientSiteLocationUuids: [],
      pendingCompanyLocation: null,
      pendingClientSiteLocation: null,
      pendingWfhLocation: null,
      wfhLocationPage: 1,
      companyLocationPage: 1,
      clientSiteLocationPage: 1,
      wfhLocationScheduleDateRange: {
        start_at: null,
        end_at: null,
      },
      companyLocationDateRange: {
        start_at: null,
        end_at: null,
      },
      clientSiteLocationDateRange: {
        start_at: null,
        end_at: null,
      },
      wfhLocationItemsPerPage: 5,
      companyLocationItemsPerPage: 5,
      clientSiteLocationItemsPerPage: 5,
      clientSiteLocationModeHeaders: [
        {
          text: '#',
          value: 'index',
          sortable: false,
          class: 'text-no-wrap',
          width: 50,
        },
        {
          text: 'ชื่อสถานที่',
          align: 'start',
          value: 'title_th',
          class: 'text-no-wrap',
        },
        { text: 'ละติจูด', value: 'latitude', class: 'text-no-wrap' },
        { text: 'ลองจิจูด', value: 'longitude', class: 'text-no-wrap' },
        { text: 'รัศมี (เมตร)', value: 'radius_meter', class: 'text-no-wrap' },
        {
          text: 'ระบุวันที่ใช้งาน',
          value: 'client_usage_date',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          class: 'text-no-wrap',
          align: 'end',
          width: 50,
        },
      ],
      companyLocationModeHeaders: [
        {
          text: '#',
          value: 'index',
          sortable: false,
          class: 'text-no-wrap',
          width: 50,
        },
        {
          text: 'ชื่อสถานที่',
          align: 'start',
          value: 'title_th',
          class: 'text-no-wrap',
        },
        { text: 'ละติจูด', value: 'latitude', class: 'text-no-wrap' },
        { text: 'ลองจิจูด', value: 'longitude', class: 'text-no-wrap' },
        { text: 'รัศมี (เมตร)', value: 'radius_meter', class: 'text-no-wrap' },
        {
          text: 'ระบุวันที่ใช้งาน',
          value: 'company_usage_date',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'end',
          width: 50,
        },
      ],
      wfhLocationHeaders: [
        {
          text: '#',
          value: 'index',
          sortable: false,
          class: 'text-no-wrap',
          width: 50,
        },
        {
          text: 'ชื่อสถานที่',
          align: 'start',
          value: 'title_th',
          class: 'text-no-wrap',
        },
        { text: 'ละติจูด', value: 'latitude', class: 'text-no-wrap' },
        { text: 'ลองจิจูด', value: 'longitude', class: 'text-no-wrap' },
        { text: 'รัศมี (เมตร)', value: 'radius_meter', class: 'text-no-wrap' },
        {
          text: 'ระบุวันที่ใช้งาน',
          value: 'wfh_usage_date',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          class: 'text-no-wrap',
          align: 'end',
          width: 100,
        },
      ],
    }
  },
  watch: {
    setTab(newVal) {
      this.tabs = newVal
    },
    formShow(newVal) {
      if (newVal) {
        this.companyOffsiteLocationsFetchedKey = ''
        this.clientOffsiteLocationsFetchedKey = ''

        this.ensureCompanyLocationModeData()
        this.ensureClientSiteLocationModeData()
        this.ensureCompanyLocationsData()
        this.ensureClientSiteLocationsData()

        this.$nextTick(() => {
          this.ensureCompanyLocationsData()
          this.ensureClientSiteLocationsData()
        })
      }
    },
    'employee.time_attendance_offsite_grant': {
      handler() {
        this.ensureCompanyLocationModeData()
        this.ensureClientSiteLocationModeData()
        this.ensureCompanyLocationsData()
        this.ensureClientSiteLocationsData()
      },
      immediate: true,
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    locationGoogleMap() {
      return this.markers.length > 0
        ? `${this.markers[0].position.lat.toFixed(
            5
          )}, ${this.markers[0].position.lng.toFixed(5)}`
        : ''
    },
    markers() {
      return this.$store.state.googleMap.markers
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
    company() {
      return this.$store.state.company.company
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    positions() {
      return this.$store.state.position.positions
    },
    employeeLevels() {
      return this.$store.state.employeeLevel.employeeLevels
    },
    employeeTypes() {
      return this.$store.state.employeeType.employeeTypes
    },
    shifts() {
      return this.$store.state.shift.shifts
    },
    genders() {
      return this.$store.state.gender.genders
    },
    prefixs() {
      return this.$store.state.prefix.prefixs
    },
    biometrics() {
      return this.$store.state.employee.biometrics
    },
    employeeBiometric() {
      return this.$store.state.employee.employeeBiometric
    },
    identifyModes() {
      return this.$store.state.hardware.identifyModes
    },
    accessAuthorities() {
      return this.$store.state.accessAuthority.accessAuthorities
    },
    companyLocations() {
      return this.$store.state.companyLocation.companyLocations || []
    },
    filteredCompanyLocations() {
      const search = (this.companyLocationSelectorSearch || '')
        .trim()
        .toLowerCase()
      const selectedCompanyLocationUuids = new Set(
        (this.getCompanyLocations() || [])
          .map((location) => location?.company_location_uuid)
          .filter(Boolean)
      )

      const locations = (this.companyLocations || []).filter((location) => {
        const locationUuid = location?.company_location_uuid
        return locationUuid
          ? !selectedCompanyLocationUuids.has(locationUuid)
          : true
      })

      if (!search) {
        return locations
      }

      return locations.filter((location) => {
        const title = (location?.title_th || '').toLowerCase()
        const latitude = `${location?.latitude || ''}`.toLowerCase()
        const longitude = `${location?.longitude || ''}`.toLowerCase()

        return (
          title.includes(search) ||
          latitude.includes(search) ||
          longitude.includes(search)
        )
      })
    },
    offsiteLocations() {
      return this.$store.state.offsiteLocation.offsiteLocations || []
    },
    filteredClientSiteLocations() {
      const search = (this.clientSiteLocationSelectorSearch || '')
        .trim()
        .toLowerCase()
      const selectedClientSiteLocationUuids = new Set(
        (this.getClientSiteLocations() || [])
          .map((location) => location?.client_site_location_uuid)
          .filter(Boolean)
      )

      const locations = (this.offsiteLocations || []).filter((location) => {
        const locationUuid = location?.client_site_location_uuid
        return locationUuid
          ? !selectedClientSiteLocationUuids.has(locationUuid)
          : true
      })

      if (!search) {
        return locations
      }

      return locations.filter((location) => {
        const title = (location?.title_th || '').toLowerCase()
        const latitude = `${location?.latitude || ''}`.toLowerCase()
        const longitude = `${location?.longitude || ''}`.toLowerCase()

        return (
          title.includes(search) ||
          latitude.includes(search) ||
          longitude.includes(search)
        )
      })
    },
    isTabEmployeeGeneralDataChange() {
      if (
        this.fileImage ||
        this.employee.is_active !== this.employeeInit.is_active ||
        this.employee.employee_reference_code !==
          this.employeeInit.employee_reference_code ||
        this.employee.employee_code !== this.employeeInit.employee_code ||
        this.employee.company_prefix_uuid !==
          this.employeeInit.company_prefix_uuid ||
        this.employee.firstname_th !== this.employeeInit.firstname_th ||
        this.employee.lastname_th !== this.employeeInit.lastname_th ||
        this.employee.firstname_en !== this.employeeInit.firstname_en ||
        this.employee.lastname_en !== this.employeeInit.lastname_en ||
        this.employee.gender_id !== this.employeeInit.gender_id ||
        this.employee.phone_no !== this.employeeInit.phone_no ||
        this.employee.email !== this.employeeInit.email ||
        this.employee.ms_entraid_email !== this.employeeInit.ms_entraid_email ||
        this.employee.birthday !== this.employeeInit.birthday ||
        this.employee.organization_uuid !==
          this.employeeInit.organization_uuid ||
        this.employee.approval_organization_uuid !==
          this.employeeInit.approval_organization_uuid ||
        this.employee.position_uuid !== this.employeeInit.position_uuid ||
        this.employee.employee_level_uuid !==
          this.employeeInit.employee_level_uuid ||
        this.employee.employee_type_uuid !==
          this.employeeInit.employee_type_uuid ||
        this.employee.shift_uuid !== this.employeeInit.shift_uuid ||
        this.employee.employee_level_code !==
          this.employeeInit.employee_level_code ||
        this.employeeInit.resign_date !== this.employee.resign_date
      ) {
        return true
      } else {
        return false
      }
    },
    isTabEmployeeIdentityDataChange() {
      if (
        this.employee.card.sn !== this.employeeInit.card.sn ||
        this.employee.pin_code !== this.employeeInit.pin_code ||
        this.employee.identify_mode !== this.employeeInit.identify_mode ||
        JSON.stringify(this.employeeInit.biometric) !==
          JSON.stringify(this.employeeBiometric)
      ) {
        return true
      } else {
        return false
      }
    },
    isTabEmployeeTimeAttendanceDataChange() {
      if (
        this.employee?.time_attendance_start_time?.toString() !==
          this.employeeInit?.time_attendance_start_time?.toString() ||
        this.employee?.time_attendance_end_time?.toString() !==
          this.employeeInit?.time_attendance_end_time?.toString()
      ) {
        return true
      } else {
        return false
      }
    },
    isAccessAuthorityDataChange() {
      if (
        JSON.stringify(this.employee.authority) !==
        JSON.stringify(this.employeeInit.authority)
      ) {
        return true
      } else {
        return false
      }
    },
    isTimeAttendanceDataChange() {
      return !_.isEqual(
        this.employee.time_attendance,
        this.employeeInit.time_attendance
      )
    },
    isTimeAttendanceOffsiteGrantDataChange() {
      return !_.isEqual(
        this.employee.time_attendance_offsite_grant,
        this.employeeInit.time_attendance_offsite_grant
      )
    },
    isWfhLocationDataChange() {
      return !_.isEqual(
        this.employee.wfh_locations,
        this.employeeInit.wfh_locations
      )
    },
    isEmployeeDataChange() {
      if (
        this.isTabEmployeeGeneralDataChange ||
        this.isTabEmployeeIdentityDataChange ||
        this.isTabEmployeeTimeAttendanceDataChange ||
        this.isAccessAuthorityDataChange ||
        this.isTimeAttendanceDataChange ||
        this.isTimeAttendanceOffsiteGrantDataChange ||
        this.isWfhLocationDataChange
      ) {
        this.$emit('isEmployeeDataChange', true)
        return true
      } else {
        this.$emit('isEmployeeDataChange', false)
        return false
      }
    },
  },
  methods: {
    ...mapActions({
      verifyCardSerialNumber: 'card/verifyCardSerialNumber',
      fetchCardTypes: 'card/fetchCardTypes',
      addCard: 'card/addCard',
      editCard: 'card/editCard',
      deleteCard: 'card/deleteCard',
      addEmployee: 'employee/addEmployee',
      editEmployee: 'employee/editEmployee',
      deleteEmployee: 'employee/deleteEmployee',
      deleteEmployeePhotoIdentifier: 'employee/deleteEmployeePhotoIdentifier',
      addEmployeeToAuthorities: 'employee/addEmployeeToAuthorities',
      editEmployeeToAuthorities: 'employee/editEmployeeToAuthorities',
      editEmployeeTimeAttendance: 'employee/editEmployeeTimeAttendance',
      addWfhLocation: 'wfhLocation/addWfhLocation',
      editWfhLocation: 'wfhLocation/editWfhLocation',
      deleteWfhLocation: 'wfhLocation/deleteWfhLocation',
      fetchCompanyLocations: 'companyLocation/fetchCompanyLocations',
      fetchOffsiteLocations: 'offsiteLocation/fetchOffsiteLocations',
      fetchOffsiteGrantCompanyLocations:
        'timeAttendanceOffsiteGrants/fetchOffsiteGrantCompanyLocations',
      addOffsiteGrantCompanyLocation:
        'timeAttendanceOffsiteGrants/addOffsiteGrantCompanyLocation',
      editOffsiteGrantCompanyLocation:
        'timeAttendanceOffsiteGrants/editOffsiteGrantCompanyLocation',
      addCompanyLocationSchedule:
        'timeAttendanceOffsiteGrants/addCompanyLocationSchedule',
      editCompanyLocationSchedule:
        'timeAttendanceOffsiteGrants/editCompanyLocationSchedule',
      deleteCompanyLocationSchedule:
        'timeAttendanceOffsiteGrants/deleteCompanyLocationSchedule',
      deleteClientSiteSchedule:
        'timeAttendanceOffsiteGrants/deleteClientSiteSchedule',
      fetchOffsiteGrantClientSiteLocations:
        'timeAttendanceOffsiteGrants/fetchOffsiteGrantClientSiteLocations',
      addOffsiteGrantClientSiteLocation:
        'timeAttendanceOffsiteGrants/addOffsiteGrantClientSiteLocation',
      editOffsiteGrantClientSiteLocation:
        'timeAttendanceOffsiteGrants/editOffsiteGrantClientSiteLocation',
      addClientSiteSchedule:
        'timeAttendanceOffsiteGrants/addClientSiteSchedule',
      editClientSiteSchedule:
        'timeAttendanceOffsiteGrants/editClientSiteSchedule',
      deleteOffsiteGrantCompanyLocation:
        'timeAttendanceOffsiteGrants/deleteOffsiteGrantCompanyLocation',
      deleteOffsiteGrantClientSiteLocation:
        'timeAttendanceOffsiteGrants/deleteOffsiteGrantClientSiteLocation',
      editTimeAttendanceOffsiteGrant:
        'timeAttendanceOffsiteGrants/editTimeAttendanceOffsiteGrant',
      employeeLastUpdated: 'hardware/employeeLastUpdated',
      addWfhLocationSchedule:
        'timeAttendanceOffsiteGrants/addWfhLocationSchedule',
      editWfhLocationSchedule:
        'timeAttendanceOffsiteGrants/editWfhLocationSchedule',
      deleteWfhLocationSchedule:
        'timeAttendanceOffsiteGrants/deleteWfhLocationSchedule',
    }),
    disabledAfterAnywhereEndAt(date) {
      const anywhereEndAt =
        this.employee.time_attendance_offsite_grant.anywhere_end_at
      if (!date || !anywhereEndAt) {
        return false
      }

      const targetDate = new Date(anywhereEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeAnywhereStartAt(date) {
      const anywhereStartAt =
        this.employee.time_attendance_offsite_grant.anywhere_start_at
      if (!date || !anywhereStartAt) {
        return false
      }

      const targetDate = new Date(anywhereStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    disabledAfterCompanyEndAt(date) {
      const companyEndAt =
        this.employee.time_attendance_offsite_grant.company_end_at
      if (!date || !companyEndAt) {
        return false
      }

      const targetDate = new Date(companyEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeCompanyStartAt(date) {
      const companyStartAt =
        this.employee.time_attendance_offsite_grant.company_start_at
      if (!date || !companyStartAt) {
        return false
      }

      const targetDate = new Date(companyStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    disabledAfterSelectedCompanyEndAt(date) {
      const companyEndAt = this.companyLocationDateRange.end_at
      if (!date || !companyEndAt) {
        return false
      }

      const targetDate = new Date(companyEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeSelectedCompanyStartAt(date) {
      const companyStartAt = this.companyLocationDateRange.start_at
      if (!date || !companyStartAt) {
        return false
      }

      const targetDate = new Date(companyStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    disabledAfterSelectedClientSiteEndAt(date) {
      const clientSiteEndAt = this.clientSiteLocationDateRange.end_at
      if (!date || !clientSiteEndAt) {
        return false
      }

      const targetDate = new Date(clientSiteEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeSelectedClientSiteStartAt(date) {
      const clientSiteStartAt = this.clientSiteLocationDateRange.start_at
      if (!date || !clientSiteStartAt) {
        return false
      }

      const targetDate = new Date(clientSiteStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    disabledAfterClientSiteEndAt(date) {
      const clientSiteEndAt =
        this.employee.time_attendance_offsite_grant.client_site_end_at
      if (!date || !clientSiteEndAt) {
        return false
      }

      const targetDate = new Date(clientSiteEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeClientSiteStartAt(date) {
      const clientSiteStartAt =
        this.employee.time_attendance_offsite_grant.client_site_start_at
      if (!date || !clientSiteStartAt) {
        return false
      }

      const targetDate = new Date(clientSiteStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    disabledAfterCheckInCheckOutEndAt(date) {
      const checkInCheckOutEndAt =
        this.employee.time_attendance_offsite_grant.check_in_out_end_at
      if (!date || !checkInCheckOutEndAt) {
        return false
      }

      const targetDate = new Date(checkInCheckOutEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeCheckInCheckOutStartAt(date) {
      const checkInCheckOutStartAt =
        this.employee.time_attendance_offsite_grant.check_in_out_start_at
      if (!date || !checkInCheckOutStartAt) {
        return false
      }

      const targetDate = new Date(checkInCheckOutStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    disabledAfterSelectedWfhScheduleEndAt(date) {
      const endAt = this.wfhLocationScheduleDateRange.end_at
      if (!date || !endAt) return false
      const targetDate = new Date(endAt)
      return Number.isNaN(targetDate.getTime()) ? false : date > targetDate
    },
    disabledBeforeSelectedWfhScheduleStartAt(date) {
      const startAt = this.wfhLocationScheduleDateRange.start_at
      if (!date || !startAt) return false
      const targetDate = new Date(startAt)
      return Number.isNaN(targetDate.getTime()) ? false : date < targetDate
    },
    disabledAfterWfhEndAt(date) {
      const wfhEndAt = this.employee.time_attendance_offsite_grant.wfh_end_at
      if (!date || !wfhEndAt) {
        return false
      }

      const targetDate = new Date(wfhEndAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date > targetDate
    },
    disabledBeforeWfhStartAt(date) {
      const wfhStartAt =
        this.employee.time_attendance_offsite_grant.wfh_start_at
      if (!date || !wfhStartAt) {
        return false
      }

      const targetDate = new Date(wfhStartAt)
      if (Number.isNaN(targetDate.getTime())) {
        return false
      }

      return date < targetDate
    },
    handleOpenWfhLocationDialog() {
      this.ensureWfhLocationsData()
      this.dialogWfhLocationList = true
    },
    ensureWfhLocationsData() {
      if (!Array.isArray(this.employee.wfh_locations)) {
        this.$set(this.employee, 'wfh_locations', [])
      }
    },
    getWfhLocationsPreview() {
      return this.getActiveWfhLocations().slice(0, 2)
    },
    getActiveWfhLocations() {
      return (this.employee.wfh_locations || []).filter(
        (location) => location?.is_active !== false
      )
    },
    getWfhLocationOverflowCount() {
      return Math.max(this.getActiveWfhLocations().length - 2, 0)
    },
    getCompanyLocations() {
      return (
        this.employee?.time_attendance_offsite_grant?.company_locations || []
      )
    },
    ensureCompanyLocationModeData() {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      if (typeof employeeOffsiteGrant.is_company_enabled !== 'boolean') {
        this.$set(employeeOffsiteGrant, 'is_company_enabled', false)
      }

      if (typeof employeeInitOffsiteGrant.is_company_enabled !== 'boolean') {
        this.$set(employeeInitOffsiteGrant, 'is_company_enabled', false)
      }

      if (
        typeof employeeOffsiteGrant.is_company_location_apply_all !== 'boolean'
      ) {
        this.$set(employeeOffsiteGrant, 'is_company_location_apply_all', true)
      }

      if (
        typeof employeeInitOffsiteGrant.is_company_location_apply_all !==
        'boolean'
      ) {
        this.$set(
          employeeInitOffsiteGrant,
          'is_company_location_apply_all',
          true
        )
      }
    },
    getCompanyLocationsPreview() {
      return this.getCompanyLocations().slice(0, 2)
    },
    getCompanyLocationOverflowCount() {
      return Math.max(this.getCompanyLocations().length - 2, 0)
    },
    mapOffsiteGrantCompanyLocation(location) {
      const locationUuid =
        location?.offsite_grant_company_location_uuid ||
        location?.company_location_uuid ||
        uuidv4()

      return {
        offsite_grant_company_location_uuid:
          location?.offsite_grant_company_location_uuid || null,
        company_location_uuid: location?.company_location_uuid || null,
        wfh_location_uuid: locationUuid,
        title_th: location?.title_th || '-',
        title_en: location?.title_en || null,
        latitude: location?.latitude || '',
        longitude: location?.longitude || '',
        radius_meter: Number(location?.radius_meter || 0),
        timezone: location?.timezone || null,
        schedules: Array.isArray(location?.schedules)
          ? location.schedules.map((schedule) => ({
              offsite_grant_company_location_schedule_uuid:
                schedule?.offsite_grant_company_location_schedule_uuid || null,
              start_at: schedule?.start_at || null,
              end_at: schedule?.end_at || null,
              created_at: schedule?.created_at || null,
              updated_at: schedule?.updated_at || null,
            }))
          : [],
        is_active: location?.is_active !== false,
        company_location_is_active:
          location?.company_location_is_active !== false,
      }
    },
    mapOffsiteGrantClientSiteLocation(location) {
      const locationUuid =
        location?.offsite_grant_client_site_location_uuid ||
        location?.client_site_location_uuid ||
        uuidv4()

      return {
        offsite_grant_client_site_location_uuid:
          location?.offsite_grant_client_site_location_uuid || null,
        client_site_location_uuid: location?.client_site_location_uuid || null,
        wfh_location_uuid: locationUuid,
        title_th: location?.title_th || '-',
        title_en: location?.title_en || null,
        latitude: location?.latitude || '',
        longitude: location?.longitude || '',
        radius_meter: Number(location?.radius_meter || 0),
        timezone: location?.timezone || null,
        schedules: Array.isArray(location?.schedules)
          ? location.schedules.map((schedule) => ({
              offsite_grant_client_site_location_schedule_uuid:
                schedule?.offsite_grant_client_site_location_schedule_uuid ||
                null,
              start_at: schedule?.start_at || null,
              end_at: schedule?.end_at || null,
              created_at: schedule?.created_at || null,
              updated_at: schedule?.updated_at || null,
            }))
          : [],
        is_active: location?.is_active !== false,
        client_site_location_is_active:
          location?.client_site_location_is_active !== false,
      }
    },
    async ensureCompanyLocationsData() {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      if (employeeOffsiteGrant.is_company_location_apply_all === true) {
        return
      }

      if (!Array.isArray(employeeOffsiteGrant.company_locations)) {
        this.$set(employeeOffsiteGrant, 'company_locations', [])
      }

      if (!Array.isArray(employeeInitOffsiteGrant.company_locations)) {
        this.$set(employeeInitOffsiteGrant, 'company_locations', [])
      }

      if ((employeeOffsiteGrant.company_locations || []).length > 0) {
        return
      }

      const { company_uuid } = this.$store.state.authentication.company || {}
      const grantUuid =
        employeeOffsiteGrant.time_attendance_offsite_grant_uuid ||
        employeeInitOffsiteGrant.time_attendance_offsite_grant_uuid

      if (!company_uuid || !grantUuid) {
        return
      }

      const fetchKey = `${company_uuid}:${grantUuid}`

      if (this.companyOffsiteLocationsLoading) {
        return
      }

      this.companyOffsiteLocationsLoading = true

      try {
        const response = await this.fetchOffsiteGrantCompanyLocations({
          company_uuid,
          time_attendance_offsite_grant_uuid: grantUuid,
          params: {
            sort: 'title_th:desc',
          },
        })

        const apiLocationsSource = Array.isArray(response?.data?.data)
          ? response.data.data
          : Array.isArray(response?.data)
          ? response.data
          : []

        const apiLocations = Array.isArray(apiLocationsSource)
          ? apiLocationsSource
          : []

        const normalizedLocations = apiLocations.map((location) =>
          this.mapOffsiteGrantCompanyLocation(location)
        )

        this.$set(
          employeeOffsiteGrant,
          'company_locations',
          _.cloneDeep(normalizedLocations)
        )
        this.$set(
          employeeInitOffsiteGrant,
          'company_locations',
          _.cloneDeep(normalizedLocations)
        )

        this.companyOffsiteLocationsFetchedKey = fetchKey
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.companyOffsiteLocationsLoading = false
      }
    },
    handleCompanyLocationModeChange(isSpecified) {
      if (!this.employee?.time_attendance_offsite_grant) {
        return
      }

      this.$set(
        this.employee.time_attendance_offsite_grant,
        'is_company_location_apply_all',
        !isSpecified
      )

      if (isSpecified) {
        this.ensureCompanyLocationsData()
      }
    },
    async handleOpenCompanyLocationDialog() {
      await this.ensureCompanyLocationsData()
      this.dialogCompanyLocationList = true
    },
    async fetchCompanyLocationDataOnce() {
      if (this.companyLocationLoading || this.isCompanyLocationFetched) {
        return
      }

      this.companyLocationLoading = true

      try {
        const { company_uuid } = this.$store.state.authentication.company
        await this.fetchCompanyLocations({
          company_uuid,
          params: {
            sort: 'title_th:asc',
          },
        })
        this.isCompanyLocationFetched = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.companyLocationLoading = false
      }
    },
    async handleOpenAddCompanyLocationDialog() {
      await this.fetchCompanyLocationDataOnce()
      this.selectedCompanyLocationUuids = []
      this.pendingCompanyLocation = null
      this.companyLocationDateRange = {
        start_at: null,
        end_at: null,
      }
      this.dialogAddCompanyLocation = true
    },
    handleSelectCompanyLocation(location) {
      const uuid =
        location?.company_location_uuid || location?.wfh_location_uuid || null
      if (!uuid) return
      const index = this.selectedCompanyLocationUuids.indexOf(uuid)
      if (index === -1) {
        this.selectedCompanyLocationUuids.push(uuid)
      } else {
        this.selectedCompanyLocationUuids.splice(index, 1)
      }
    },
    async handleSubmitSelectedCompanyLocation() {
      if (this.selectedCompanyLocationUuids.length === 0) {
        return
      }

      const selectedLocations = (this.companyLocations || []).filter(
        (location) =>
          this.selectedCompanyLocationUuids.includes(
            location.company_location_uuid || location.wfh_location_uuid
          )
      )

      if (selectedLocations.length === 0) {
        return
      }

      this.companyLocationDateRange = { start_at: null, end_at: null }
      this.dialogAddCompanyLocation = false
      for (const location of selectedLocations) {
        await this.handleAddCompanyLocation(location)
      }
    },
    handleOpenLocationSchedules(location) {
      this.pendingCompanyLocation = _.cloneDeep(location)
      this.companyLocationDateRange = { start_at: null, end_at: null }
      this.dialogCompanyLocationDateRange = true
    },
    handleOpenAddCompanyLocationScheduleDialog() {
      this.companyLocationDateRange = { start_at: null, end_at: null }
      this.dialogAddCompanyLocationSchedule = true
    },
    async handleConfirmCompanyLocationDateRange() {
      if (!this.pendingCompanyLocation) {
        return
      }

      if (
        !this.companyLocationDateRange.start_at &&
        !this.companyLocationDateRange.end_at
      ) {
        this.dialogAddCompanyLocationSchedule = false
        return
      }

      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      const isAdded = await this.handleAddCompanyLocationSchedule(
        this.pendingCompanyLocation
      )

      if (isAdded) {
        this.companyLocationDateRange = { start_at: null, end_at: null }
        this.dialogAddCompanyLocationSchedule = false
      }
    },
    async handleAddCompanyLocationSchedule(location) {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant || !location) {
        return false
      }

      const newSchedule = {
        offsite_grant_company_location_schedule_uuid: uuidv4(),
        start_at: this.companyLocationDateRange.start_at || null,
        end_at: this.companyLocationDateRange.end_at || null,
        created_at: null,
        updated_at: null,
      }

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (!company_uuid || !timeAttendanceOffsiteGrantUuid) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company หรือ offsite grant',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }

        try {
          let offsiteGrantCompanyLocationUuid =
            location?.offsite_grant_company_location_uuid || null

          if (!offsiteGrantCompanyLocationUuid) {
            const latestLocationsResponse =
              await this.fetchOffsiteGrantCompanyLocations({
                company_uuid,
                time_attendance_offsite_grant_uuid:
                  timeAttendanceOffsiteGrantUuid,
                params: { sort: 'title_th:desc' },
              })

            const latestLocations = Array.isArray(
              latestLocationsResponse?.data?.data
            )
              ? latestLocationsResponse.data.data
              : Array.isArray(latestLocationsResponse?.data)
              ? latestLocationsResponse.data
              : []

            const matched = latestLocations.find((item) => {
              if (
                item?.company_location_uuid &&
                item.company_location_uuid === location?.company_location_uuid
              )
                return true
              return (
                item?.title_th === location?.title_th &&
                Number(item?.latitude) === Number(location?.latitude) &&
                Number(item?.longitude) === Number(location?.longitude)
              )
            })

            if (matched) {
              offsiteGrantCompanyLocationUuid =
                matched.offsite_grant_company_location_uuid || null

              // update local state so subsequent calls don't need to refetch
              const normalized = this.mapOffsiteGrantCompanyLocation(matched)
              const updateLocations = (locations) =>
                (locations || []).map((item) =>
                  item.wfh_location_uuid === location?.wfh_location_uuid ||
                  (item.company_location_uuid &&
                    item.company_location_uuid ===
                      location?.company_location_uuid)
                    ? { ...item, ...normalized }
                    : item
                )
              this.$set(
                employeeOffsiteGrant,
                'company_locations',
                updateLocations(employeeOffsiteGrant.company_locations)
              )
              this.$set(
                employeeInitOffsiteGrant,
                'company_locations',
                updateLocations(employeeInitOffsiteGrant.company_locations)
              )
              if (this.pendingCompanyLocation) {
                this.pendingCompanyLocation = {
                  ...this.pendingCompanyLocation,
                  ...normalized,
                }
              }
            }
          }

          if (!offsiteGrantCompanyLocationUuid) {
            throw new Error('ไม่พบ offsite_grant_company_location_uuid')
          }

          const startAt = this.companyLocationDateRange.start_at
            ? this.applyLocationTimezone(
                moment(this.companyLocationDateRange.start_at),
                location.timezone
              ).format()
            : null
          const endAt = this.companyLocationDateRange.end_at
            ? this.applyLocationTimezone(
                moment(this.companyLocationDateRange.end_at),
                location.timezone
              )
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .format()
            : null

          const created = await this.addCompanyLocationSchedule({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            offsite_grant_company_location_uuid:
              offsiteGrantCompanyLocationUuid,
            data: { schedules: [{ start_at: startAt, end_at: endAt }] },
          })

          const createdData = created?.data || created || null
          if (
            Array.isArray(createdData?.schedules) &&
            createdData.schedules.length > 0
          ) {
            newSchedule.offsite_grant_company_location_schedule_uuid =
              createdData.schedules[createdData.schedules.length - 1]
                ?.offsite_grant_company_location_schedule_uuid ||
              newSchedule.offsite_grant_company_location_schedule_uuid
            newSchedule.start_at =
              createdData.schedules[createdData.schedules.length - 1]
                ?.start_at || newSchedule.start_at
            newSchedule.end_at =
              createdData.schedules[createdData.schedules.length - 1]?.end_at ||
              newSchedule.end_at
          }
        } catch (error) {
          console.log(error)
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }
      }

      const isSameLocation = (item) =>
        (location?.offsite_grant_company_location_uuid &&
          item.offsite_grant_company_location_uuid ===
            location.offsite_grant_company_location_uuid) ||
        (location?.company_location_uuid &&
          item.company_location_uuid === location.company_location_uuid) ||
        (location?.wfh_location_uuid &&
          item.wfh_location_uuid === location.wfh_location_uuid)

      const updateLocations = (locations) =>
        (locations || []).map((item) =>
          isSameLocation(item)
            ? { ...item, schedules: [...(item.schedules || []), newSchedule] }
            : item
        )

      this.$set(
        employeeOffsiteGrant,
        'company_locations',
        updateLocations(employeeOffsiteGrant.company_locations)
      )
      this.$set(
        employeeInitOffsiteGrant,
        'company_locations',
        updateLocations(employeeInitOffsiteGrant.company_locations)
      )

      if (this.pendingCompanyLocation) {
        this.pendingCompanyLocation = {
          ...this.pendingCompanyLocation,
          schedules: [
            ...(this.pendingCompanyLocation.schedules || []),
            _.cloneDeep(newSchedule),
          ],
        }
      }

      return true
    },
    onDeleteCompanyLocationSchedule(schedule, index) {
      this.confirmDialogDeleteCompanyLocationSchedule = true
      this.confirmDialogDeleteCompanyLocationScheduleData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบวันที่ใช้งาน',
        value: this.formatCompanyLocationScheduleLabel(
          schedule,
          this.pendingCompanyLocation?.timezone
        ),
        item: { schedule, index },
      }
    },
    cancelConfirmDialogDeleteCompanyLocationSchedule() {
      this.confirmDialogDeleteCompanyLocationSchedule = false
    },
    async submitConfirmDialogDeleteCompanyLocationSchedule(item) {
      this.confirmDialogDeleteCompanyLocationScheduleLoading = true
      try {
        if (item?.deleteAll) {
          await this.removeAllPendingCompanyLocationSchedules()
        } else {
          await this.removePendingCompanyLocationSchedule(item?.index)
        }
        this.confirmDialogDeleteCompanyLocationSchedule = false
      } finally {
        this.confirmDialogDeleteCompanyLocationScheduleLoading = false
      }
    },
    onDeleteAllCompanyLocationSchedules() {
      const schedules = this.getCompanyLocationSchedules(
        this.pendingCompanyLocation
      )
      if (!schedules.length) return
      this.confirmDialogDeleteCompanyLocationSchedule = true
      this.confirmDialogDeleteCompanyLocationScheduleData = {
        title: 'ยืนยันการลบทั้งหมด',
        text: 'คุณต้องการลบวันที่ใช้งานทั้งหมดของสถานที่นี้',
        value: `${schedules.length} รายการ`,
        item: { deleteAll: true },
      }
    },
    async removeAllPendingCompanyLocationSchedules() {
      if (!this.pendingCompanyLocation) return

      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid
        const offsiteGrantCompanyLocationUuid =
          this.pendingCompanyLocation?.offsite_grant_company_location_uuid

        if (
          company_uuid &&
          timeAttendanceOffsiteGrantUuid &&
          offsiteGrantCompanyLocationUuid
        ) {
          try {
            await this.deleteCompanyLocationSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              offsite_grant_company_location_uuid:
                offsiteGrantCompanyLocationUuid,
              delete_all: true,
              offsite_grant_company_location_schedule_uuids: [],
            })
          } catch (error) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }
        }
      }

      this.pendingCompanyLocation = {
        ...this.pendingCompanyLocation,
        schedules: [],
      }

      const isSameLocation = (item) =>
        (this.pendingCompanyLocation?.offsite_grant_company_location_uuid &&
          item.offsite_grant_company_location_uuid ===
            this.pendingCompanyLocation.offsite_grant_company_location_uuid) ||
        (this.pendingCompanyLocation?.company_location_uuid &&
          item.company_location_uuid ===
            this.pendingCompanyLocation.company_location_uuid) ||
        (this.pendingCompanyLocation?.wfh_location_uuid &&
          item.wfh_location_uuid ===
            this.pendingCompanyLocation.wfh_location_uuid)

      const clearSchedules = (locations) =>
        (locations || []).map((item) =>
          isSameLocation(item) ? { ...item, schedules: [] } : item
        )

      if (employeeOffsiteGrant) {
        this.$set(
          employeeOffsiteGrant,
          'company_locations',
          clearSchedules(employeeOffsiteGrant.company_locations)
        )
      }
      if (employeeInitOffsiteGrant) {
        this.$set(
          employeeInitOffsiteGrant,
          'company_locations',
          clearSchedules(employeeInitOffsiteGrant.company_locations)
        )
      }
    },
    async removePendingCompanyLocationSchedule(index) {
      if (!this.pendingCompanyLocation) return

      const schedules = this.getCompanyLocationSchedules(
        this.pendingCompanyLocation
      )
      const schedule = schedules[index]
      if (!schedule) return

      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant
      const scheduleUuid =
        schedule?.offsite_grant_company_location_schedule_uuid

      if (this.formAction === 'edit' && scheduleUuid) {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid
        const offsiteGrantCompanyLocationUuid =
          this.pendingCompanyLocation?.offsite_grant_company_location_uuid

        if (
          company_uuid &&
          timeAttendanceOffsiteGrantUuid &&
          offsiteGrantCompanyLocationUuid
        ) {
          try {
            await this.deleteCompanyLocationSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              offsite_grant_company_location_uuid:
                offsiteGrantCompanyLocationUuid,
              offsite_grant_company_location_schedule_uuid: scheduleUuid,
              delete_all: false,
            })
          } catch (error) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }
        }
      }

      const filteredSchedules = (
        this.pendingCompanyLocation.schedules || []
      ).filter(
        (s) =>
          s !== schedule &&
          s.offsite_grant_company_location_schedule_uuid !== scheduleUuid
      )
      this.pendingCompanyLocation = {
        ...this.pendingCompanyLocation,
        schedules: filteredSchedules,
      }

      const isSameLocation = (item) =>
        (this.pendingCompanyLocation?.offsite_grant_company_location_uuid &&
          item.offsite_grant_company_location_uuid ===
            this.pendingCompanyLocation.offsite_grant_company_location_uuid) ||
        (this.pendingCompanyLocation?.company_location_uuid &&
          item.company_location_uuid ===
            this.pendingCompanyLocation.company_location_uuid) ||
        (this.pendingCompanyLocation?.wfh_location_uuid &&
          item.wfh_location_uuid ===
            this.pendingCompanyLocation.wfh_location_uuid)

      const removeScheduleFromList = (locations) =>
        (locations || []).map((item) =>
          isSameLocation(item)
            ? {
                ...item,
                schedules: (item.schedules || []).filter(
                  (s) =>
                    s.offsite_grant_company_location_schedule_uuid !==
                    scheduleUuid
                ),
              }
            : item
        )

      if (employeeOffsiteGrant) {
        this.$set(
          employeeOffsiteGrant,
          'company_locations',
          removeScheduleFromList(employeeOffsiteGrant.company_locations)
        )
      }
      if (employeeInitOffsiteGrant) {
        this.$set(
          employeeInitOffsiteGrant,
          'company_locations',
          removeScheduleFromList(employeeInitOffsiteGrant.company_locations)
        )
      }
    },
    handleCancelCompanyLocationDateRange() {
      this.dialogCompanyLocationDateRange = false
      this.pendingCompanyLocation = null
      this.companyLocationDateRange = {
        start_at: null,
        end_at: null,
      }
      // re-sync list from state after editing
      this.ensureCompanyLocationsData()
    },
    async handleAddCompanyLocation(location) {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant || !location) {
        return false
      }

      const locationUuid = location.company_location_uuid || uuidv4()

      const nextLocation = {
        company_location_uuid: location.company_location_uuid || null,
        wfh_location_uuid: locationUuid,
        title_th: location.title_th || '-',
        latitude: location.latitude || '',
        longitude: location.longitude || '',
        radius_meter: Number(location.radius_meter || 0),
        timezone: location.timezone || null,
        schedules:
          this.companyLocationDateRange.start_at ||
          this.companyLocationDateRange.end_at
            ? [
                {
                  offsite_grant_company_location_schedule_uuid: uuidv4(),
                  start_at: this.companyLocationDateRange.start_at || null,
                  end_at: this.companyLocationDateRange.end_at || null,
                  created_at: null,
                  updated_at: null,
                },
              ]
            : [],
      }

      const isSameLocation = (item) =>
        item.wfh_location_uuid === nextLocation.wfh_location_uuid ||
        (item.company_location_uuid &&
          item.company_location_uuid === nextLocation.company_location_uuid)

      if ((employeeOffsiteGrant.company_locations || []).some(isSameLocation)) {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 2000,
          message: 'สถานที่นี้ถูกเลือกแล้ว',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
        return false
      }

      let persistedLocation = _.cloneDeep(nextLocation)

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (!company_uuid || !timeAttendanceOffsiteGrantUuid) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company หรือ offsite grant',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }

        try {
          const existingCompanyLocationUuids = (
            employeeOffsiteGrant.company_locations || []
          )
            .map((item) => item?.company_location_uuid)
            .filter(Boolean)

          const companyLocationUuids = Array.from(
            new Set([
              ...existingCompanyLocationUuids,
              nextLocation.company_location_uuid,
            ])
          )

          const createdLocation = await this.addOffsiteGrantCompanyLocation({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            data: {
              apply_all: false,
              company_location_uuids: companyLocationUuids,
            },
          })
          const createdLocationData = createdLocation?.data || createdLocation

          if (
            createdLocationData?.company_location_uuid ||
            createdLocationData?.offsite_grant_company_location_uuid
          ) {
            const normalizedCreatedLocation =
              this.mapOffsiteGrantCompanyLocation(createdLocationData)
            persistedLocation = {
              ...nextLocation,
              ...normalizedCreatedLocation,
              timezone:
                normalizedCreatedLocation?.timezone || nextLocation.timezone,
              schedules:
                Array.isArray(normalizedCreatedLocation?.schedules) &&
                normalizedCreatedLocation.schedules.length > 0
                  ? normalizedCreatedLocation.schedules
                  : nextLocation.schedules,
            }
          }

          const startAt = this.companyLocationDateRange.start_at
            ? this.applyLocationTimezone(
                moment(this.companyLocationDateRange.start_at),
                location.timezone
              ).format()
            : ''
          const endAt = this.companyLocationDateRange.end_at
            ? this.applyLocationTimezone(
                moment(this.companyLocationDateRange.end_at),
                location.timezone
              )
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .format()
            : ''
          const hasDateRange = Boolean(startAt || endAt)
          const schedulePayload = {
            start_at: startAt || null,
            end_at: endAt || null,
          }
          let offsiteGrantCompanyLocationUuid =
            persistedLocation?.offsite_grant_company_location_uuid || null

          if (hasDateRange) {
            if (!offsiteGrantCompanyLocationUuid) {
              const latestLocationsResponse =
                await this.fetchOffsiteGrantCompanyLocations({
                  company_uuid,
                  time_attendance_offsite_grant_uuid:
                    timeAttendanceOffsiteGrantUuid,
                  params: {
                    sort: 'title_th:desc',
                  },
                })

              const latestLocationsSource = Array.isArray(
                latestLocationsResponse?.data?.data
              )
                ? latestLocationsResponse.data.data
                : Array.isArray(latestLocationsResponse?.data)
                ? latestLocationsResponse.data
                : []

              const latestLocations = Array.isArray(latestLocationsSource)
                ? latestLocationsSource
                : []

              const matchedLocation = latestLocations.find((item) => {
                const matchedByCompanyLocationUuid =
                  item?.company_location_uuid &&
                  item.company_location_uuid ===
                    persistedLocation?.company_location_uuid

                if (matchedByCompanyLocationUuid) {
                  return true
                }

                return (
                  item?.title_th === persistedLocation?.title_th &&
                  Number(item?.latitude) ===
                    Number(persistedLocation?.latitude) &&
                  Number(item?.longitude) ===
                    Number(persistedLocation?.longitude)
                )
              })

              if (matchedLocation) {
                const normalizedMatchedLocation =
                  this.mapOffsiteGrantCompanyLocation(matchedLocation)
                persistedLocation = {
                  ...persistedLocation,
                  ...normalizedMatchedLocation,
                }
                offsiteGrantCompanyLocationUuid =
                  normalizedMatchedLocation.offsite_grant_company_location_uuid
              }
            }

            if (!offsiteGrantCompanyLocationUuid) {
              throw new Error('ไม่พบ offsite_grant_company_location_uuid')
            }

            const createdSchedule = await this.addCompanyLocationSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              offsite_grant_company_location_uuid:
                offsiteGrantCompanyLocationUuid,
              data: {
                schedules: [schedulePayload],
              },
            })
            const createdScheduleData =
              createdSchedule?.data || createdSchedule || null

            if (
              Array.isArray(createdScheduleData?.schedules) &&
              createdScheduleData.schedules.length > 0
            ) {
              persistedLocation = {
                ...persistedLocation,
                schedules: createdScheduleData.schedules,
              }
            } else {
              persistedLocation = {
                ...persistedLocation,
                schedules: [
                  {
                    offsite_grant_company_location_schedule_uuid:
                      persistedLocation?.schedules?.[0]
                        ?.offsite_grant_company_location_schedule_uuid ||
                      uuidv4(),
                    start_at: startAt || null,
                    end_at: endAt || null,
                    created_at:
                      persistedLocation?.schedules?.[0]?.created_at || null,
                    updated_at:
                      persistedLocation?.schedules?.[0]?.updated_at || null,
                  },
                ],
              }
            }
          }
        } catch (error) {
          console.log(error)
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }
      }

      this.$set(employeeOffsiteGrant, 'company_locations', [
        ...(employeeOffsiteGrant.company_locations || []),
        persistedLocation,
      ])

      this.$set(employeeInitOffsiteGrant, 'company_locations', [
        ...(employeeInitOffsiteGrant.company_locations || []),
        _.cloneDeep(persistedLocation),
      ])

      this.dialogAddCompanyLocation = false
      return true
    },
    async handleDeleteCompanyLocation(location) {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant || !location) {
        return
      }

      const offsiteGrantCompanyLocationUuid =
        location?.offsite_grant_company_location_uuid
      const companyLocationUuid = location?.company_location_uuid
      const wfhLocationUuid = location?.wfh_location_uuid
      const timeAttendanceOffsiteGrantUuid =
        employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
        employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

      if (this.formAction === 'edit' && offsiteGrantCompanyLocationUuid) {
        try {
          const { company_uuid } =
            this.$store.state.authentication.company || {}

          if (!company_uuid) {
            throw new Error('company_uuid is required')
          }

          await this.deleteOffsiteGrantCompanyLocation({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            offsite_grant_company_location_uuid:
              offsiteGrantCompanyLocationUuid,
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }
      }

      const isSameLocation = (item) =>
        (offsiteGrantCompanyLocationUuid &&
          item.offsite_grant_company_location_uuid ===
            offsiteGrantCompanyLocationUuid) ||
        (companyLocationUuid &&
          item.company_location_uuid === companyLocationUuid) ||
        (wfhLocationUuid && item.wfh_location_uuid === wfhLocationUuid)

      this.$set(
        employeeOffsiteGrant,
        'company_locations',
        (employeeOffsiteGrant.company_locations || []).filter(
          (item) => !isSameLocation(item)
        )
      )

      this.$set(
        employeeInitOffsiteGrant,
        'company_locations',
        (employeeInitOffsiteGrant.company_locations || []).filter(
          (item) => !isSameLocation(item)
        )
      )
    },
    async handleDeleteAllCompanyLocations() {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (!company_uuid || !timeAttendanceOffsiteGrantUuid) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company หรือ offsite grant',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }

        try {
          await this.deleteOffsiteGrantCompanyLocation({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            data: {
              delete_all: true,
              offsite_grant_company_location_uuids: [],
            },
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }
      }

      this.$set(employeeOffsiteGrant, 'company_locations', [])
      this.$set(employeeInitOffsiteGrant, 'company_locations', [])
    },
    onDeleteCompanyLocation(location) {
      if (!location) {
        return
      }

      this.confirmDialogDeleteCompanyLocation = true
      this.confirmDialogDeleteCompanyLocationData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบสถานที่ลงเวลาที่บริษัทและสาขา',
        value: `${location.title_th || '-'} (${location.latitude || '-'}, ${
          location.longitude || '-'
        })`,
        item: {
          delete_all: false,
          location,
        },
      }
    },
    onDeleteAllCompanyLocations() {
      const companyLocations = this.getCompanyLocations() || []
      if (companyLocations.length === 0) {
        return
      }

      this.confirmDialogDeleteCompanyLocation = true
      this.confirmDialogDeleteCompanyLocationData = {
        title: 'ยืนยันการลบทั้งหมด',
        text: 'คุณต้องการลบสถานที่ลงเวลาที่บริษัทและสาขาทั้งหมด',
        value: `${companyLocations.length} รายการ`,
        item: {
          delete_all: true,
        },
      }
    },
    cancelConfirmDialogDeleteCompanyLocation() {
      this.confirmDialogDeleteCompanyLocation = false
    },
    async submitConfirmDialogDeleteCompanyLocation(payload) {
      this.confirmDialogDeleteCompanyLocationLoading = true

      try {
        if (payload?.target === 'client_site' && payload?.delete_all) {
          await this.handleDeleteAllClientSiteLocations()
        } else if (payload?.target === 'client_site' && payload?.location) {
          await this.handleDeleteClientSiteLocation(payload.location)
        } else if (payload?.delete_all) {
          await this.handleDeleteAllCompanyLocations()
        } else if (payload?.location) {
          await this.handleDeleteCompanyLocation(payload.location)
        }

        this.confirmDialogDeleteCompanyLocation = false
      } finally {
        this.confirmDialogDeleteCompanyLocationLoading = false
      }
    },
    getClientSiteLocations() {
      return (
        this.employee?.time_attendance_offsite_grant?.client_site_locations ||
        []
      )
    },
    getClientSiteLocationsPreview() {
      return this.getClientSiteLocations().slice(0, 2)
    },
    getClientSiteLocationOverflowCount() {
      return Math.max(this.getClientSiteLocations().length - 2, 0)
    },
    ensureClientSiteLocationModeData() {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      if (typeof employeeOffsiteGrant.is_client_site_apply_all !== 'boolean') {
        this.$set(
          employeeOffsiteGrant,
          'is_client_site_apply_all',
          typeof employeeOffsiteGrant.is_client_site_location_enabled ===
            'boolean'
            ? !employeeOffsiteGrant.is_client_site_location_enabled
            : true
        )
      }

      if (
        typeof employeeInitOffsiteGrant.is_client_site_apply_all !== 'boolean'
      ) {
        this.$set(
          employeeInitOffsiteGrant,
          'is_client_site_apply_all',
          typeof employeeInitOffsiteGrant.is_client_site_location_enabled ===
            'boolean'
            ? !employeeInitOffsiteGrant.is_client_site_location_enabled
            : true
        )
      }
    },
    async ensureClientSiteLocationsData() {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      if (!Array.isArray(employeeOffsiteGrant.client_site_locations)) {
        this.$set(employeeOffsiteGrant, 'client_site_locations', [])
      }

      if (!Array.isArray(employeeInitOffsiteGrant.client_site_locations)) {
        this.$set(employeeInitOffsiteGrant, 'client_site_locations', [])
      }

      if ((employeeOffsiteGrant.client_site_locations || []).length > 0) {
        return
      }

      const { company_uuid } = this.$store.state.authentication.company || {}
      const grantUuid =
        employeeOffsiteGrant.time_attendance_offsite_grant_uuid ||
        employeeInitOffsiteGrant.time_attendance_offsite_grant_uuid

      if (!company_uuid || !grantUuid) {
        return
      }

      const fetchKey = `${company_uuid}:${grantUuid}`

      if (
        this.clientOffsiteLocationsLoading ||
        this.clientOffsiteLocationsFetchedKey === fetchKey
      ) {
        return
      }

      this.clientOffsiteLocationsLoading = true

      try {
        const response = await this.fetchOffsiteGrantClientSiteLocations({
          company_uuid,
          time_attendance_offsite_grant_uuid: grantUuid,
          params: {
            sort: 'title_th:asc',
          },
        })

        const apiLocationsSource = Array.isArray(response?.data?.data)
          ? response.data.data
          : Array.isArray(response?.data)
          ? response.data
          : []

        const apiLocations = Array.isArray(apiLocationsSource)
          ? apiLocationsSource
          : []

        const normalizedLocations = apiLocations.map((location) =>
          this.mapOffsiteGrantClientSiteLocation(location)
        )

        this.$set(
          employeeOffsiteGrant,
          'client_site_locations',
          _.cloneDeep(normalizedLocations)
        )
        this.$set(
          employeeInitOffsiteGrant,
          'client_site_locations',
          _.cloneDeep(normalizedLocations)
        )

        this.clientOffsiteLocationsFetchedKey = fetchKey
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.clientOffsiteLocationsLoading = false
      }
    },
    async fetchClientSiteLocationDataOnce() {
      if (this.clientSiteLocationLoading || this.isClientSiteLocationFetched) {
        return
      }

      this.clientSiteLocationLoading = true

      try {
        const { company_uuid } = this.$store.state.authentication.company
        await this.fetchOffsiteLocations({
          company_uuid,
          params: {
            sort: 'title_th:asc',
          },
        })
        this.isClientSiteLocationFetched = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.clientSiteLocationLoading = false
      }
    },
    async handleOpenClientSiteLocationDialog() {
      await this.ensureClientSiteLocationsData()
      this.dialogClientSiteLocationList = true
    },
    async handleOpenAddClientSiteLocationDialog() {
      await this.fetchClientSiteLocationDataOnce()
      this.selectedClientSiteLocationUuids = []
      this.pendingClientSiteLocation = null
      this.clientSiteLocationDateRange = {
        start_at: null,
        end_at: null,
      }
      this.dialogAddClientSiteLocation = true
    },
    handleSelectClientSiteLocation(location) {
      const uuid =
        location?.client_site_location_uuid ||
        location?.wfh_location_uuid ||
        null
      if (!uuid) return
      const index = this.selectedClientSiteLocationUuids.indexOf(uuid)
      if (index === -1) {
        this.selectedClientSiteLocationUuids.push(uuid)
      } else {
        this.selectedClientSiteLocationUuids.splice(index, 1)
      }
    },
    async handleSubmitSelectedClientSiteLocation() {
      if (this.selectedClientSiteLocationUuids.length === 0) {
        return
      }

      const selectedLocations = (this.offsiteLocations || []).filter(
        (location) =>
          this.selectedClientSiteLocationUuids.includes(
            location.client_site_location_uuid || location.wfh_location_uuid
          )
      )

      if (selectedLocations.length === 0) {
        return
      }

      this.clientSiteLocationDateRange = { start_at: null, end_at: null }
      this.dialogAddClientSiteLocation = false
      for (const location of selectedLocations) {
        await this.handleAddClientSiteLocation(location)
      }
    },
    handleOpenClientSiteLocationSchedules(location) {
      this.pendingClientSiteLocation = _.cloneDeep(location)
      this.clientSiteLocationDateRange = { start_at: null, end_at: null }
      this.dialogClientSiteLocationDateRange = true
    },
    handleOpenAddClientSiteLocationScheduleDialog() {
      this.clientSiteLocationDateRange = { start_at: null, end_at: null }
      this.dialogAddClientSiteLocationSchedule = true
    },
    async handleConfirmClientSiteLocationDateRange() {
      if (!this.pendingClientSiteLocation) {
        return
      }

      if (
        !this.clientSiteLocationDateRange.start_at &&
        !this.clientSiteLocationDateRange.end_at
      ) {
        this.dialogAddClientSiteLocationSchedule = false
        return
      }

      const isAdded = await this.handleAddClientSiteLocationSchedule(
        this.pendingClientSiteLocation
      )

      if (isAdded) {
        this.dialogAddClientSiteLocationSchedule = false
        this.clientSiteLocationDateRange = { start_at: null, end_at: null }
      }
    },
    handleCancelClientSiteLocationDateRange() {
      this.dialogClientSiteLocationDateRange = false
      this.pendingClientSiteLocation = null
      this.clientSiteLocationDateRange = { start_at: null, end_at: null }
    },
    async handleAddClientSiteLocationSchedule(location) {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant || !location) {
        return false
      }

      const newSchedule = {
        offsite_grant_client_site_location_schedule_uuid: uuidv4(),
        start_at: this.clientSiteLocationDateRange.start_at || null,
        end_at: this.clientSiteLocationDateRange.end_at || null,
        created_at: null,
        updated_at: null,
      }

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (!company_uuid || !timeAttendanceOffsiteGrantUuid) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company หรือ offsite grant',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }

        try {
          let offsiteGrantClientSiteLocationUuid =
            location?.offsite_grant_client_site_location_uuid || null

          if (!offsiteGrantClientSiteLocationUuid) {
            const latestLocationsResponse =
              await this.fetchOffsiteGrantClientSiteLocations({
                company_uuid,
                time_attendance_offsite_grant_uuid:
                  timeAttendanceOffsiteGrantUuid,
                params: { sort: 'title_th:asc' },
              })

            const latestLocations = Array.isArray(
              latestLocationsResponse?.data?.data
            )
              ? latestLocationsResponse.data.data
              : Array.isArray(latestLocationsResponse?.data)
              ? latestLocationsResponse.data
              : []

            const matched = latestLocations.find((item) => {
              if (
                item?.client_site_location_uuid &&
                item.client_site_location_uuid ===
                  location?.client_site_location_uuid
              )
                return true
              return (
                item?.title_th === location?.title_th &&
                Number(item?.latitude) === Number(location?.latitude) &&
                Number(item?.longitude) === Number(location?.longitude)
              )
            })

            if (matched) {
              offsiteGrantClientSiteLocationUuid =
                matched.offsite_grant_client_site_location_uuid || null

              const normalized = this.mapOffsiteGrantClientSiteLocation(matched)
              const updateLocations = (locations) =>
                (locations || []).map((item) =>
                  item.wfh_location_uuid === location?.wfh_location_uuid ||
                  (item.client_site_location_uuid &&
                    item.client_site_location_uuid ===
                      location?.client_site_location_uuid)
                    ? { ...item, ...normalized }
                    : item
                )
              this.$set(
                employeeOffsiteGrant,
                'client_site_locations',
                updateLocations(employeeOffsiteGrant.client_site_locations)
              )
              this.$set(
                employeeInitOffsiteGrant,
                'client_site_locations',
                updateLocations(employeeInitOffsiteGrant.client_site_locations)
              )
              if (this.pendingClientSiteLocation) {
                this.pendingClientSiteLocation = {
                  ...this.pendingClientSiteLocation,
                  ...normalized,
                }
              }
            }
          }

          if (!offsiteGrantClientSiteLocationUuid) {
            throw new Error('ไม่พบ offsite_grant_client_site_location_uuid')
          }

          const startAt = this.clientSiteLocationDateRange.start_at
            ? this.applyLocationTimezone(
                moment(this.clientSiteLocationDateRange.start_at),
                location.timezone
              ).format()
            : null
          const endAt = this.clientSiteLocationDateRange.end_at
            ? this.applyLocationTimezone(
                moment(this.clientSiteLocationDateRange.end_at),
                location.timezone
              )
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .format()
            : null

          const created = await this.addClientSiteSchedule({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            offsite_grant_client_site_location_uuid:
              offsiteGrantClientSiteLocationUuid,
            data: { schedules: [{ start_at: startAt, end_at: endAt }] },
          })

          const createdData = created?.data || created || null
          if (
            Array.isArray(createdData?.schedules) &&
            createdData.schedules.length > 0
          ) {
            newSchedule.offsite_grant_client_site_location_schedule_uuid =
              createdData.schedules[createdData.schedules.length - 1]
                ?.offsite_grant_client_site_location_schedule_uuid ||
              newSchedule.offsite_grant_client_site_location_schedule_uuid
            newSchedule.start_at =
              createdData.schedules[createdData.schedules.length - 1]
                ?.start_at || newSchedule.start_at
            newSchedule.end_at =
              createdData.schedules[createdData.schedules.length - 1]?.end_at ||
              newSchedule.end_at
          }
        } catch (error) {
          console.log(error)
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }
      }

      const isSameLocation = (item) =>
        (location?.offsite_grant_client_site_location_uuid &&
          item.offsite_grant_client_site_location_uuid ===
            location.offsite_grant_client_site_location_uuid) ||
        (location?.client_site_location_uuid &&
          item.client_site_location_uuid ===
            location.client_site_location_uuid) ||
        (location?.wfh_location_uuid &&
          item.wfh_location_uuid === location.wfh_location_uuid)

      const updateLocations = (locations) =>
        (locations || []).map((item) =>
          isSameLocation(item)
            ? { ...item, schedules: [...(item.schedules || []), newSchedule] }
            : item
        )

      this.$set(
        employeeOffsiteGrant,
        'client_site_locations',
        updateLocations(employeeOffsiteGrant.client_site_locations)
      )
      this.$set(
        employeeInitOffsiteGrant,
        'client_site_locations',
        updateLocations(employeeInitOffsiteGrant.client_site_locations)
      )

      if (this.pendingClientSiteLocation) {
        this.pendingClientSiteLocation = {
          ...this.pendingClientSiteLocation,
          schedules: [
            ...(this.pendingClientSiteLocation.schedules || []),
            _.cloneDeep(newSchedule),
          ],
        }
      }

      return true
    },
    onDeleteClientSiteLocationSchedule(schedule, index) {
      this.confirmDialogDeleteClientSiteLocationSchedule = true
      this.confirmDialogDeleteClientSiteLocationScheduleData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบวันที่ใช้งาน',
        value: this.formatClientSiteLocationScheduleLabel(
          schedule,
          this.pendingClientSiteLocation?.timezone
        ),
        item: { schedule, index },
      }
    },
    cancelConfirmDialogDeleteClientSiteLocationSchedule() {
      this.confirmDialogDeleteClientSiteLocationSchedule = false
    },
    async submitConfirmDialogDeleteClientSiteLocationSchedule(item) {
      this.confirmDialogDeleteClientSiteLocationScheduleLoading = true
      try {
        if (item?.deleteAll) {
          await this.removeAllPendingClientSiteLocationSchedules()
        } else {
          await this.removePendingClientSiteLocationSchedule(item?.index)
        }
        this.confirmDialogDeleteClientSiteLocationSchedule = false
      } finally {
        this.confirmDialogDeleteClientSiteLocationScheduleLoading = false
      }
    },
    onDeleteAllClientSiteLocationSchedules() {
      const schedules = this.getClientSiteLocationSchedules(
        this.pendingClientSiteLocation
      )
      if (schedules.length === 0) return

      this.confirmDialogDeleteClientSiteLocationSchedule = true
      this.confirmDialogDeleteClientSiteLocationScheduleData = {
        title: 'ยืนยันการลบทั้งหมด',
        text: 'คุณต้องการลบวันที่ทั้งหมด',
        value: `${schedules.length} รายการ`,
        item: { deleteAll: true },
      }
    },
    async removeAllPendingClientSiteLocationSchedules() {
      if (!this.pendingClientSiteLocation) return

      if (this.formAction === 'edit') {
        const employeeOffsiteGrant =
          this.employee?.time_attendance_offsite_grant
        const employeeInitOffsiteGrant =
          this.employeeInit?.time_attendance_offsite_grant
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid
        const offsiteGrantClientSiteLocationUuid =
          this.pendingClientSiteLocation
            ?.offsite_grant_client_site_location_uuid

        if (
          company_uuid &&
          timeAttendanceOffsiteGrantUuid &&
          offsiteGrantClientSiteLocationUuid
        ) {
          try {
            await this.deleteClientSiteSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              offsite_grant_client_site_location_uuid:
                offsiteGrantClientSiteLocationUuid,
              delete_all: true,
              offsite_grant_client_site_location_schedule_uuids: [],
            })
          } catch (error) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }
        }
      }

      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      this.pendingClientSiteLocation = {
        ...this.pendingClientSiteLocation,
        schedules: [],
      }

      const isSameLocation = (item) =>
        (this.pendingClientSiteLocation
          ?.offsite_grant_client_site_location_uuid &&
          item.offsite_grant_client_site_location_uuid ===
            this.pendingClientSiteLocation
              .offsite_grant_client_site_location_uuid) ||
        (this.pendingClientSiteLocation?.client_site_location_uuid &&
          item.client_site_location_uuid ===
            this.pendingClientSiteLocation.client_site_location_uuid) ||
        (this.pendingClientSiteLocation?.wfh_location_uuid &&
          item.wfh_location_uuid ===
            this.pendingClientSiteLocation.wfh_location_uuid)

      const updateLocations = (locations) =>
        (locations || []).map((item) =>
          isSameLocation(item) ? { ...item, schedules: [] } : item
        )

      if (employeeOffsiteGrant) {
        this.$set(
          employeeOffsiteGrant,
          'client_site_locations',
          updateLocations(employeeOffsiteGrant.client_site_locations)
        )
      }
      if (employeeInitOffsiteGrant) {
        this.$set(
          employeeInitOffsiteGrant,
          'client_site_locations',
          updateLocations(employeeInitOffsiteGrant.client_site_locations)
        )
      }
    },
    async removePendingClientSiteLocationSchedule(index) {
      if (!this.pendingClientSiteLocation) return

      const schedule = (this.pendingClientSiteLocation.schedules || [])[index]

      if (this.formAction === 'edit') {
        const employeeOffsiteGrant =
          this.employee?.time_attendance_offsite_grant
        const employeeInitOffsiteGrant =
          this.employeeInit?.time_attendance_offsite_grant
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid
        const offsiteGrantClientSiteLocationUuid =
          this.pendingClientSiteLocation
            ?.offsite_grant_client_site_location_uuid
        const scheduleUuid =
          schedule?.offsite_grant_client_site_location_schedule_uuid

        if (
          company_uuid &&
          timeAttendanceOffsiteGrantUuid &&
          offsiteGrantClientSiteLocationUuid &&
          scheduleUuid
        ) {
          try {
            await this.deleteClientSiteSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              offsite_grant_client_site_location_uuid:
                offsiteGrantClientSiteLocationUuid,
              delete_all: false,
              offsite_grant_client_site_location_schedule_uuids: [scheduleUuid],
            })
          } catch (error) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }
        }
      }

      const updatedSchedules = (
        this.pendingClientSiteLocation.schedules || []
      ).filter((_, i) => i !== index)

      this.pendingClientSiteLocation = {
        ...this.pendingClientSiteLocation,
        schedules: updatedSchedules,
      }

      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      const isSameLocation = (item) =>
        (this.pendingClientSiteLocation
          ?.offsite_grant_client_site_location_uuid &&
          item.offsite_grant_client_site_location_uuid ===
            this.pendingClientSiteLocation
              .offsite_grant_client_site_location_uuid) ||
        (this.pendingClientSiteLocation?.client_site_location_uuid &&
          item.client_site_location_uuid ===
            this.pendingClientSiteLocation.client_site_location_uuid) ||
        (this.pendingClientSiteLocation?.wfh_location_uuid &&
          item.wfh_location_uuid ===
            this.pendingClientSiteLocation.wfh_location_uuid)

      const updateLocations = (locations) =>
        (locations || []).map((item) =>
          isSameLocation(item) ? { ...item, schedules: updatedSchedules } : item
        )

      if (employeeOffsiteGrant) {
        this.$set(
          employeeOffsiteGrant,
          'client_site_locations',
          updateLocations(employeeOffsiteGrant.client_site_locations)
        )
      }
      if (employeeInitOffsiteGrant) {
        this.$set(
          employeeInitOffsiteGrant,
          'client_site_locations',
          updateLocations(employeeInitOffsiteGrant.client_site_locations)
        )
      }
    },
    async handleAddClientSiteLocation(location) {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant || !location) {
        return false
      }

      const locationUuid = location.client_site_location_uuid || uuidv4()

      const nextLocation = {
        client_site_location_uuid: location.client_site_location_uuid || null,
        wfh_location_uuid: locationUuid,
        title_th: location.title_th || '-',
        latitude: location.latitude || '',
        longitude: location.longitude || '',
        radius_meter: Number(location.radius_meter || 0),
        timezone: location.timezone || null,
        schedules:
          this.clientSiteLocationDateRange.start_at ||
          this.clientSiteLocationDateRange.end_at
            ? [
                {
                  offsite_grant_client_site_location_schedule_uuid: uuidv4(),
                  start_at: this.clientSiteLocationDateRange.start_at || null,
                  end_at: this.clientSiteLocationDateRange.end_at || null,
                  created_at: null,
                  updated_at: null,
                },
              ]
            : [],
      }

      const isSameLocation = (item) =>
        item.wfh_location_uuid === nextLocation.wfh_location_uuid ||
        (item.client_site_location_uuid &&
          item.client_site_location_uuid ===
            nextLocation.client_site_location_uuid)

      const clientSiteLocations =
        employeeOffsiteGrant.client_site_locations || []

      if (clientSiteLocations.some(isSameLocation)) {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 2000,
          message: 'สถานที่นี้ถูกเลือกแล้ว',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
        return false
      }

      let persistedLocation = _.cloneDeep(nextLocation)

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (!company_uuid || !timeAttendanceOffsiteGrantUuid) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company หรือ offsite grant',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }

        try {
          const existingClientSiteLocationUuids = (
            employeeOffsiteGrant.client_site_locations || []
          )
            .map((item) => item?.client_site_location_uuid)
            .filter(Boolean)

          const clientSiteLocationUuids = Array.from(
            new Set([
              ...existingClientSiteLocationUuids,
              nextLocation.client_site_location_uuid,
            ])
          )

          const createdLocation = await this.addOffsiteGrantClientSiteLocation({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            data: {
              apply_all: false,
              client_site_location_uuids: clientSiteLocationUuids,
            },
          })
          const createdLocationData = createdLocation?.data || createdLocation

          if (
            createdLocationData?.client_site_location_uuid ||
            createdLocationData?.offsite_grant_client_site_location_uuid
          ) {
            const normalizedCreatedLocation =
              this.mapOffsiteGrantClientSiteLocation(createdLocationData)
            persistedLocation = {
              ...nextLocation,
              ...normalizedCreatedLocation,
              timezone:
                normalizedCreatedLocation?.timezone || nextLocation.timezone,
              schedules:
                Array.isArray(normalizedCreatedLocation?.schedules) &&
                normalizedCreatedLocation.schedules.length > 0
                  ? normalizedCreatedLocation.schedules
                  : nextLocation.schedules,
            }
          }

          const startAt = this.clientSiteLocationDateRange.start_at
            ? this.applyLocationTimezone(
                moment(this.clientSiteLocationDateRange.start_at),
                location.timezone
              ).format()
            : ''
          const endAt = this.clientSiteLocationDateRange.end_at
            ? this.applyLocationTimezone(
                moment(this.clientSiteLocationDateRange.end_at),
                location.timezone
              )
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .format()
            : ''
          const hasDateRange = Boolean(startAt || endAt)
          const schedulePayload = {
            start_at: startAt || null,
            end_at: endAt || null,
          }

          let offsiteGrantClientSiteLocationUuid =
            persistedLocation?.offsite_grant_client_site_location_uuid || null

          if (hasDateRange) {
            if (!offsiteGrantClientSiteLocationUuid) {
              const latestLocationsResponse =
                await this.fetchOffsiteGrantClientSiteLocations({
                  company_uuid,
                  time_attendance_offsite_grant_uuid:
                    timeAttendanceOffsiteGrantUuid,
                  params: {
                    sort: 'title_th:asc',
                  },
                })

              const latestLocationsSource = Array.isArray(
                latestLocationsResponse?.data?.data
              )
                ? latestLocationsResponse.data.data
                : Array.isArray(latestLocationsResponse?.data)
                ? latestLocationsResponse.data
                : []

              const latestLocations = Array.isArray(latestLocationsSource)
                ? latestLocationsSource
                : []

              const matchedLocation = latestLocations.find((item) => {
                const matchedByClientSiteLocationUuid =
                  item?.client_site_location_uuid &&
                  item.client_site_location_uuid ===
                    persistedLocation?.client_site_location_uuid

                if (matchedByClientSiteLocationUuid) {
                  return true
                }

                return (
                  item?.title_th === persistedLocation?.title_th &&
                  Number(item?.latitude) ===
                    Number(persistedLocation?.latitude) &&
                  Number(item?.longitude) ===
                    Number(persistedLocation?.longitude)
                )
              })

              if (matchedLocation) {
                const normalizedMatchedLocation =
                  this.mapOffsiteGrantClientSiteLocation(matchedLocation)
                persistedLocation = {
                  ...persistedLocation,
                  ...normalizedMatchedLocation,
                }
                offsiteGrantClientSiteLocationUuid =
                  normalizedMatchedLocation.offsite_grant_client_site_location_uuid
              }
            }

            if (!offsiteGrantClientSiteLocationUuid) {
              throw new Error('ไม่พบ offsite_grant_client_site_location_uuid')
            }

            const createdSchedule = await this.addClientSiteSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              offsite_grant_client_site_location_uuid:
                offsiteGrantClientSiteLocationUuid,
              data: {
                schedules: [schedulePayload],
              },
            })
            const createdScheduleData =
              createdSchedule?.data || createdSchedule || null

            if (
              Array.isArray(createdScheduleData?.schedules) &&
              createdScheduleData.schedules.length > 0
            ) {
              persistedLocation = {
                ...persistedLocation,
                schedules: createdScheduleData.schedules,
              }
            } else {
              persistedLocation = {
                ...persistedLocation,
                schedules: [
                  {
                    offsite_grant_client_site_location_schedule_uuid:
                      persistedLocation?.schedules?.[0]
                        ?.offsite_grant_client_site_location_schedule_uuid ||
                      uuidv4(),
                    start_at: startAt || null,
                    end_at: endAt || null,
                    created_at:
                      persistedLocation?.schedules?.[0]?.created_at || null,
                    updated_at:
                      persistedLocation?.schedules?.[0]?.updated_at || null,
                  },
                ],
              }
            }
          }
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return false
        }
      }

      this.$set(employeeOffsiteGrant, 'client_site_locations', [
        ...(employeeOffsiteGrant.client_site_locations || []),
        persistedLocation,
      ])

      this.$set(employeeInitOffsiteGrant, 'client_site_locations', [
        ...(employeeInitOffsiteGrant.client_site_locations || []),
        _.cloneDeep(persistedLocation),
      ])

      this.dialogAddClientSiteLocation = false
      return true
    },
    async handleDeleteClientSiteLocation(location) {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant || !location) {
        return
      }

      const offsiteGrantClientSiteLocationUuid =
        location?.offsite_grant_client_site_location_uuid
      const clientSiteLocationUuid = location?.client_site_location_uuid
      const wfhLocationUuid = location?.wfh_location_uuid
      const timeAttendanceOffsiteGrantUuid =
        employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
        employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

      if (this.formAction === 'edit' && offsiteGrantClientSiteLocationUuid) {
        try {
          const { company_uuid } =
            this.$store.state.authentication.company || {}

          if (!company_uuid) {
            throw new Error('company_uuid is required')
          }

          await this.deleteOffsiteGrantClientSiteLocation({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            offsite_grant_client_site_location_uuid:
              offsiteGrantClientSiteLocationUuid,
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }
      }

      const isSameLocation = (item) =>
        (offsiteGrantClientSiteLocationUuid &&
          item.offsite_grant_client_site_location_uuid ===
            offsiteGrantClientSiteLocationUuid) ||
        (clientSiteLocationUuid &&
          item.client_site_location_uuid === clientSiteLocationUuid) ||
        (wfhLocationUuid && item.wfh_location_uuid === wfhLocationUuid)

      this.$set(
        employeeOffsiteGrant,
        'client_site_locations',
        (employeeOffsiteGrant.client_site_locations || []).filter(
          (item) => !isSameLocation(item)
        )
      )

      this.$set(
        employeeInitOffsiteGrant,
        'client_site_locations',
        (employeeInitOffsiteGrant.client_site_locations || []).filter(
          (item) => !isSameLocation(item)
        )
      )
    },
    async handleDeleteAllClientSiteLocations() {
      const employeeOffsiteGrant = this.employee?.time_attendance_offsite_grant
      const employeeInitOffsiteGrant =
        this.employeeInit?.time_attendance_offsite_grant

      if (!employeeOffsiteGrant || !employeeInitOffsiteGrant) {
        return
      }

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (!company_uuid || !timeAttendanceOffsiteGrantUuid) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company หรือ offsite grant',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }

        try {
          await this.deleteOffsiteGrantClientSiteLocation({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            data: {
              delete_all: true,
              offsite_grant_client_site_location_uuids: [],
            },
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }
      }

      this.$set(employeeOffsiteGrant, 'client_site_locations', [])
      this.$set(employeeInitOffsiteGrant, 'client_site_locations', [])
    },
    onDeleteClientSiteLocation(location) {
      if (!location) {
        return
      }

      this.confirmDialogDeleteCompanyLocation = true
      this.confirmDialogDeleteCompanyLocationData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบสถานที่ลงเวลาที่บริษัทลูกค้า',
        value: `${location.title_th || '-'} (${location.latitude || '-'}, ${
          location.longitude || '-'
        })`,
        item: {
          target: 'client_site',
          delete_all: false,
          location,
        },
      }
    },
    onDeleteAllClientSiteLocations() {
      const clientSiteLocations = this.getClientSiteLocations() || []
      if (clientSiteLocations.length === 0) {
        return
      }

      this.confirmDialogDeleteCompanyLocation = true
      this.confirmDialogDeleteCompanyLocationData = {
        title: 'ยืนยันการลบทั้งหมด',
        text: 'คุณต้องการลบสถานที่ลงเวลาที่บริษัทลูกค้าทั้งหมด',
        value: `${clientSiteLocations.length} รายการ`,
        item: {
          target: 'client_site',
          delete_all: true,
        },
      }
    },
    handleClientSiteLocationModeChange(isSpecified) {
      this.$set(
        this.employee.time_attendance_offsite_grant,
        'is_client_site_apply_all',
        !isSpecified
      )

      if (isSpecified) {
        this.ensureClientSiteLocationsData()
      }
    },
    onDeleteAllWfhLocations() {
      const wfhLocations = this.employee.wfh_locations || []
      if (wfhLocations.length === 0) return

      this.confirmDialogDeleteWfhLocation = true
      this.confirmDialogDeleteWfhLocationData = {
        title: 'ยืนยันการลบทั้งหมด',
        text: 'คุณต้องการลบสถานที่ลงเวลาที่บ้านทั้งหมด',
        value: `${wfhLocations.length} รายการ`,
        item: { delete_all: true },
      }
    },
    handleOpenWfhLocationSchedules(location) {
      this.pendingWfhLocation = _.cloneDeep(location)
      this.wfhLocationScheduleDateRange = { start_at: null, end_at: null }
      this.dialogWfhLocationDateRange = true
    },
    handleOpenAddWfhLocationScheduleDialog() {
      this.wfhLocationScheduleDateRange = { start_at: null, end_at: null }
      this.dialogAddWfhLocationSchedule = true
    },
    async handleConfirmWfhLocationSchedule() {
      if (!this.pendingWfhLocation) return
      if (
        !this.wfhLocationScheduleDateRange.start_at &&
        !this.wfhLocationScheduleDateRange.end_at
      ) {
        this.dialogAddWfhLocationSchedule = false
        return
      }

      const newSchedule = {
        wfh_location_schedule_uuid: uuidv4(),
        start_at: this.wfhLocationScheduleDateRange.start_at || null,
        end_at: this.wfhLocationScheduleDateRange.end_at || null,
      }

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const wfhLocationUuid = this.pendingWfhLocation?.wfh_location_uuid
        const employeeOffsiteGrant =
          this.employee?.time_attendance_offsite_grant
        const employeeInitOffsiteGrant =
          this.employeeInit?.time_attendance_offsite_grant
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (
          !company_uuid ||
          !wfhLocationUuid ||
          !timeAttendanceOffsiteGrantUuid
        ) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: 'ไม่พบข้อมูล company, offsite grant หรือ wfh location',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }

        try {
          const startAt = this.wfhLocationScheduleDateRange.start_at
            ? this.applyLocationTimezone(
                moment(this.wfhLocationScheduleDateRange.start_at),
                this.pendingWfhLocation.timezone
              ).format()
            : null
          const endAt = this.wfhLocationScheduleDateRange.end_at
            ? this.applyLocationTimezone(
                moment(this.wfhLocationScheduleDateRange.end_at),
                this.pendingWfhLocation.timezone
              )
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .format()
            : null

          const created = await this.addWfhLocationSchedule({
            company_uuid,
            time_attendance_offsite_grant_uuid: timeAttendanceOffsiteGrantUuid,
            wfh_location_uuid: wfhLocationUuid,
            data: { schedules: [{ start_at: startAt, end_at: endAt }] },
          })

          const createdData = created?.data || created || null
          if (
            Array.isArray(createdData?.schedules) &&
            createdData.schedules.length > 0
          ) {
            const last = createdData.schedules[createdData.schedules.length - 1]
            newSchedule.wfh_location_schedule_uuid =
              last?.wfh_location_schedule_uuid ||
              newSchedule.wfh_location_schedule_uuid
            newSchedule.start_at = last?.start_at || newSchedule.start_at
            newSchedule.end_at = last?.end_at || newSchedule.end_at
          }
        } catch (error) {
          console.log(error)
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }
      }

      this.pendingWfhLocation = {
        ...this.pendingWfhLocation,
        schedules: [...(this.pendingWfhLocation.schedules || []), newSchedule],
      }

      this.employee.wfh_locations = (this.employee.wfh_locations || []).map(
        (loc) =>
          loc.wfh_location_uuid === this.pendingWfhLocation.wfh_location_uuid
            ? { ...loc, schedules: this.pendingWfhLocation.schedules }
            : loc
      )

      this.dialogAddWfhLocationSchedule = false
      this.wfhLocationScheduleDateRange = { start_at: null, end_at: null }
    },
    handleCancelWfhLocationDateRange() {
      this.dialogWfhLocationDateRange = false
      this.pendingWfhLocation = null
      this.wfhLocationScheduleDateRange = { start_at: null, end_at: null }
    },
    onDeleteWfhLocationSchedule(schedule, index) {
      this.confirmDialogDeleteWfhLocationSchedule = true
      this.confirmDialogDeleteWfhLocationScheduleData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบวันที่ใช้งาน',
        value: this.formatWfhLocationScheduleLabel(
          schedule,
          this.pendingWfhLocation?.timezone
        ),
        item: { index },
      }
    },
    cancelConfirmDialogDeleteWfhLocationSchedule() {
      this.confirmDialogDeleteWfhLocationSchedule = false
    },
    async submitConfirmDialogDeleteWfhLocationSchedule(item) {
      this.confirmDialogDeleteWfhLocationScheduleLoading = true
      try {
        if (item?.deleteAll) {
          await this.removeAllPendingWfhLocationSchedules()
        } else {
          await this.removePendingWfhLocationSchedule(item?.index)
        }
        this.confirmDialogDeleteWfhLocationSchedule = false
      } finally {
        this.confirmDialogDeleteWfhLocationScheduleLoading = false
      }
    },
    onDeleteAllWfhLocationSchedules() {
      const schedules = this.getWfhLocationSchedules(this.pendingWfhLocation)
      if (schedules.length === 0) return

      this.confirmDialogDeleteWfhLocationSchedule = true
      this.confirmDialogDeleteWfhLocationScheduleData = {
        title: 'ยืนยันการลบทั้งหมด',
        text: 'คุณต้องการลบวันที่ใช้งานทั้งหมดของสถานที่นี้',
        value: `${schedules.length} รายการ`,
        item: { deleteAll: true },
      }
    },
    async removeAllPendingWfhLocationSchedules() {
      if (!this.pendingWfhLocation) return

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const wfhLocationUuid = this.pendingWfhLocation?.wfh_location_uuid
        const employeeOffsiteGrant =
          this.employee?.time_attendance_offsite_grant
        const employeeInitOffsiteGrant =
          this.employeeInit?.time_attendance_offsite_grant
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (company_uuid && wfhLocationUuid && timeAttendanceOffsiteGrantUuid) {
          try {
            await this.deleteWfhLocationSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              wfh_location_uuid: wfhLocationUuid,
              delete_all: true,
              wfh_location_schedule_uuids: [],
            })
          } catch (error) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }
        }
      }

      this.pendingWfhLocation = { ...this.pendingWfhLocation, schedules: [] }
      this.employee.wfh_locations = (this.employee.wfh_locations || []).map(
        (loc) =>
          loc.wfh_location_uuid === this.pendingWfhLocation.wfh_location_uuid
            ? { ...loc, schedules: [] }
            : loc
      )
    },
    async removePendingWfhLocationSchedule(index) {
      if (!this.pendingWfhLocation) return

      const schedule = (this.pendingWfhLocation.schedules || [])[index]
      const scheduleUuid = schedule?.wfh_location_schedule_uuid

      if (this.formAction === 'edit') {
        const { company_uuid } = this.$store.state.authentication.company || {}
        const wfhLocationUuid = this.pendingWfhLocation?.wfh_location_uuid
        const employeeOffsiteGrant =
          this.employee?.time_attendance_offsite_grant
        const employeeInitOffsiteGrant =
          this.employeeInit?.time_attendance_offsite_grant
        const timeAttendanceOffsiteGrantUuid =
          employeeOffsiteGrant?.time_attendance_offsite_grant_uuid ||
          employeeInitOffsiteGrant?.time_attendance_offsite_grant_uuid

        if (
          company_uuid &&
          timeAttendanceOffsiteGrantUuid &&
          wfhLocationUuid &&
          scheduleUuid
        ) {
          try {
            await this.deleteWfhLocationSchedule({
              company_uuid,
              time_attendance_offsite_grant_uuid:
                timeAttendanceOffsiteGrantUuid,
              wfh_location_uuid: wfhLocationUuid,
              delete_all: false,
              wfh_location_schedule_uuids: [scheduleUuid],
            })
          } catch (error) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }
        }
      }

      const updatedSchedules = (this.pendingWfhLocation.schedules || []).filter(
        (_, i) => i !== index
      )

      this.pendingWfhLocation = {
        ...this.pendingWfhLocation,
        schedules: updatedSchedules,
      }
      this.employee.wfh_locations = (this.employee.wfh_locations || []).map(
        (loc) =>
          loc.wfh_location_uuid === this.pendingWfhLocation.wfh_location_uuid
            ? { ...loc, schedules: updatedSchedules }
            : loc
      )
    },
    hasWfhLocationSchedules(location) {
      return this.getWfhLocationSchedules(location).length > 0
    },
    getWfhLocationSchedules(location) {
      if (!Array.isArray(location?.schedules)) return []
      return location.schedules.filter((s) => s?.start_at || s?.end_at)
    },
    formatWfhLocationScheduleLabel(schedule, timezone = null) {
      const startDate = this.formatDateDisplay(schedule?.start_at, timezone)
      const endDate = this.formatDateDisplay(schedule?.end_at, timezone)
      const start = startDate !== '-' ? startDate : 'ไม่ระบุ'
      const end = endDate !== '-' ? endDate : 'ไม่ระบุ'
      return `${start} - ${end}`
    },
    getWfhLocationFirstScheduleLabel(location) {
      const first = this.getWfhLocationSchedules(location)[0]
      return first
        ? this.formatWfhLocationScheduleLabel(first, location?.timezone)
        : '-'
    },
    getWfhLocationScheduleOverflowCount(location) {
      return Math.max(this.getWfhLocationSchedules(location).length - 1, 0)
    },
    getWfhLocationScheduleButtonLabel(location) {
      const overflow = this.getWfhLocationScheduleOverflowCount(location)
      return overflow > 0 ? `+${overflow}` : 'เพิ่ม'
    },
    handleAddWfhLocation() {
      this.wfhLocation = {
        wfh_location_type_action: 'add',
      }
      this.wfhLocationInit = { ...this.wfhLocation }
      this.dialogAddWfhLocation = true
    },
    handleEditWfhLocation(selectedWfhLocation) {
      if (selectedWfhLocation?.wfh_location_uuid) {
        this.wfhLocation = {
          ...selectedWfhLocation,
          wfh_location_type_action: 'edit',
        }
        this.wfhLocationInit = { ...this.wfhLocation }
        this.dialogAddWfhLocation = true
        return
      }

      if (this.employee.wfh_locations.length > 0) {
        this.wfhLocation = {
          ...this.employee.wfh_locations[0],
          wfh_location_type_action: 'edit',
        }
        this.wfhLocationInit = { ...this.wfhLocation }
        this.dialogAddWfhLocation = true
      }
    },
    handleDeleteWfhLocation(wfh_location_uuid) {
      this.employee.wfh_locations = this.employee.wfh_locations.filter(
        (wfhLocation) => wfhLocation.wfh_location_uuid !== wfh_location_uuid
      )
      this.wfhLocation = {}
      // this.$refs.formWfhLocation.resetValidation()
    },
    onDeleteWfhLocation(wfhLocation) {
      this.confirmDialogDeleteWfhLocation = true
      this.confirmDialogDeleteWfhLocationData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบสถานที่ลงเวลาที่บ้าน',
        value: `${wfhLocation.title_th} (${wfhLocation.latitude}, ${wfhLocation.longitude})`,
        item: wfhLocation,
      }
    },
    cancelConfirmDialogDeleteWfhLocation() {
      this.confirmDialogDeleteWfhLocation = false
    },
    async submitConfirmDialogDeleteWfhLocation(wfhLocation) {
      this.confirmDialogDeleteWfhLocationLoading = true

      try {
        if (wfhLocation?.delete_all) {
          if (this.formAction === 'edit') {
            const { company_uuid } = this.$store.state.authentication.company
            await Promise.all(
              (this.employee.wfh_locations || [])
                .filter((loc) => loc.wfh_location_uuid)
                .map((loc) =>
                  this.deleteWfhLocation({
                    company_uuid,
                    wfh_location_uuid: loc.wfh_location_uuid,
                  })
                )
            )
          }

          this.employee.wfh_locations = []
          if (this.formAction === 'edit') {
            this.employeeInit.wfh_locations = []
          }
          this.confirmDialogDeleteWfhLocation = false
          return
        }

        if (wfhLocation?.wfh_location_uuid) {
          if (this.formAction === 'edit') {
            const { company_uuid } = this.$store.state.authentication.company

            await this.deleteWfhLocation({
              company_uuid,
              wfh_location_uuid: wfhLocation.wfh_location_uuid,
            })

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'ลบสถานที่ลงเวลาที่บ้านสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }

          this.handleDeleteWfhLocation(wfhLocation.wfh_location_uuid)
          if (this.formAction === 'edit') {
            this.employeeInit.wfh_locations = _.cloneDeep(
              this.employee.wfh_locations
            )
          }
        }

        this.confirmDialogDeleteWfhLocation = false
        this.$refs.formWfhLocation?.resetValidation()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteWfhLocationLoading = false
      }
    },
    async handleSubmitWfhLocation() {
      if (this.$refs?.formWfhLocation.validate()) {
        const timezoneName = tzlookup(
          this.wfhLocation.latitude,
          this.wfhLocation.longitude
        )

        const offset = this.getOffsetStr(timezoneName)
        this.wfhLocation.timezone = offset
        if (this.wfhLocation.wfh_location_type_action === 'add') {
          if (this.formAction === 'add') {
            this.wfhLocation.wfh_location_uuid = uuidv4()
            this.employee.wfh_locations = [
              ...(this.employee.wfh_locations || []),
              { ...this.wfhLocation },
            ]
          } else {
            try {
              const { company_uuid } = this.$store.state.authentication.company

              const createdWfhLocation = await this.addWfhLocation({
                company_uuid,
                data: {
                  employee_uuid: this.employee.employee_uuid,
                  title_th: this.wfhLocation.title_th,
                  title_en: this.wfhLocation.title_en,
                  latitude: this.wfhLocation.latitude,
                  longitude: this.wfhLocation.longitude,
                  radius_meter: parseInt(this.wfhLocation.radius_meter, 10),
                  timezone: this.wfhLocation.timezone,
                  is_active: true,
                },
              })

              const normalizedCreatedWfhLocation = {
                ...this.wfhLocation,
                ...createdWfhLocation,
              }

              this.employee.wfh_locations = [
                ...(this.employee.wfh_locations || []),
                normalizedCreatedWfhLocation,
              ]
              this.employeeInit.wfh_locations = _.cloneDeep(
                this.employee.wfh_locations
              )

              const snackbar = {
                show: true,
                color: 'success',
                timeout: 2000,
                message: 'เพิ่มสถานที่ลงเวลาที่บ้านสำเร็จ',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
            } catch (error) {
              const snackbar = {
                show: true,
                color: 'error',
                timeout: -1,
                message:
                  error?.response?.data?.message || 'Something went wrong!',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }
          }
        } else {
          if (this.formAction === 'edit') {
            try {
              const { company_uuid } = this.$store.state.authentication.company

              await this.editWfhLocation({
                company_uuid,
                wfh_location_uuid: this.wfhLocation.wfh_location_uuid,
                data: {
                  employee_uuid: this.employee.employee_uuid,
                  title_th: this.wfhLocation.title_th,
                  title_en: this.wfhLocation.title_en,
                  latitude: this.wfhLocation.latitude,
                  longitude: this.wfhLocation.longitude,
                  radius_meter: parseInt(this.wfhLocation.radius_meter, 10),
                  timezone: this.wfhLocation.timezone,
                  is_active: true,
                },
              })

              const snackbar = {
                show: true,
                color: 'success',
                timeout: 2000,
                message: 'แก้ไขสถานที่ลงเวลาที่บ้านสำเร็จ',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
            } catch (error) {
              const snackbar = {
                show: true,
                color: 'error',
                timeout: -1,
                message:
                  error?.response?.data?.message || 'Something went wrong!',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }
          }

          this.employee.wfh_locations = (this.employee.wfh_locations || []).map(
            (wfhLocation) => {
              return wfhLocation.wfh_location_uuid ===
                this.wfhLocation.wfh_location_uuid
                ? { ...this.wfhLocation }
                : wfhLocation
            }
          )
          if (this.formAction === 'edit') {
            this.employeeInit.wfh_locations = _.cloneDeep(
              this.employee.wfh_locations
            )
          }
        }
        this.dialogAddWfhLocation = false

        this.wfhLocation = { ...this.wfhLocationInit }
        this.$refs.formWfhLocation.resetValidation()
      }
    },
    handleCancelWfhLocation() {
      this.dialogAddWfhLocation = false

      this.wfhLocation = { ...this.wfhLocationInit }
      this.$refs.formWfhLocation.resetValidation()
    },
    onOpenLocationGoogleMapDialog() {
      if (this.wfhLocation.latitude && this.wfhLocation.longitude) {
        const markers = []
        const latLng = {
          lat: parseFloat(this.wfhLocation.latitude),
          lng: parseFloat(this.wfhLocation.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
      }
      this.googleMapDialog = true
    },
    onSubmitLocationGoogleMapDialog() {
      if (this.locationGoogleMap) {
        const location = this.locationGoogleMap.split(', ')
        const lat = location[0]
        const lng = location[1]

        this.wfhLocation.latitude = lat
        this.wfhLocation.longitude = lng

        this.googleMapDialog = false
      } else {
        this.googleMapDialog = false
      }
    },
    getOffsetStr(timeZone) {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'longOffset',
      })

      const parts = formatter.formatToParts(new Date())
      const tzPart = parts.find((part) => part.type === 'timeZoneName')

      return tzPart ? tzPart.value.replace('GMT', '') : '+00:00'
    },
    onCancelLocationGoogleMapDialog() {
      if (this.formAction === 'add') {
        this.$store.commit('googleMap/SET_MARKERS', [])

        this.wfhLocation.latitude = ''
        this.wfhLocation.longitude = ''
      } else {
        // this.$emit('onReset', this.formAction)
        const markers = []
        const latLng = {
          lat: parseFloat(this.wfhLocationInit.latitude),
          lng: parseFloat(this.wfhLocationInit.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
        this.wfhLocation.latitude = this.wfhLocationInit.latitude
        this.wfhLocation.longitude = this.wfhLocationInit.longitude
      }
      this.googleMapDialog = false
    },
    getTzString(offset) {
      const secInHour = 3600
      const secInMin = 60

      let isNagativeOffset = offset < 0
      let positiveOffset = Math.abs(offset)

      // hour
      let h = '' + Math.floor(positiveOffset / secInHour)
      while (h.length < 2) {
        h = '0' + h
      }
      if (isNagativeOffset) {
        h = '-' + h
      } else {
        h = '+' + h
      }

      // minute
      let m = ((positiveOffset % secInHour) / secInHour) * secInMin

      return `${h}:${m === 0 ? '00' : m}`
    },
    getOrganizationBoss(organization_uuid) {
      const organizationBoss = this.organizations.find(
        (org) => org.organization_uuid === organization_uuid
      )?.organization_boss

      return organizationBoss
        ? `${organizationBoss.firstname_th} ${organizationBoss.lastname_th}`
        : '-'
    },
    handleOrganizationChange(value) {
      if (!this.employee.approval_organization_uuid) {
        this.$emit('onChangeOrganization', value)
      }
    },
    handleDeleteEmployeePhotoIdentifier() {
      this.confirmDialogDeleteEmployeePhotoIdentifier = true
      this.confirmDialogDeleteEmployeePhotoIdentifierData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบรูป Profile',
        value: '',
        item: '',
      }
    },
    cancelConfirmDialogDeleteEmployeePhotoIdentifier() {
      this.confirmDialogDeleteEmployeePhotoIdentifier = false
    },
    submitConfirmDialogDeleteEmployeePhotoIdentifier() {
      this.confirmDialogDeleteEmployeePhotoIdentifierLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_uuid: this.employee.employee_uuid,
      }

      this.deleteEmployeePhotoIdentifier(payload)
        .then(() => {
          this.confirmDialogDeleteEmployeePhotoIdentifierLoading = false
          this.confirmDialogDeleteEmployeePhotoIdentifier = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.employee.url_photo_identifier = null

          this.$store.commit('employee/EDIT_EMPLOYEE', { ...this.employee })
        })
        .catch((error) => {
          this.confirmDialogDeleteEmployeePhotoIdentifierLoading = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบพนักงาน',
        value: `${this.employee.employee_code} : ${this.employee.firstname_th} ${this.employee.lastname_th}`,
        item: this.employee,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(employee) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDialogDeleteLoading = true

        await this.deleteEmployee({
          company_uuid,
          employee_uuid: employee.employee_uuid,
        })

        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.resetValidation()
      } catch (error) {
        this.confirmDialogDeleteLoading = false

        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async handleEmployeeLastUpdated() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.isEmployeeLastUpdated = true

        await this.employeeLastUpdated({
          company_uuid,
          employee_uuid: this.employee.employee_uuid,
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'อัพเดทข้อมูลล่าสุดของพนักงานสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.isEmployeeLastUpdated = false
      }
    },
    handleEmployeeResetPassword() {
      this.confirmDialogResetPassword = true
      this.confirmDialogDataResetPassword = {
        title: 'ต้องการรีเซ็ตรหัสผ่านพนักงานหรือไม่ ?',
        text: 'รหัสผ่านของพนักงานจะถูกรีเซ็ตให้ตรงกับรหัสพนักงาน',
        negativeBtn: 'รีเซ็ตรหัสผ่าน',
      }
    },
    cancelConfirmDialogResetPassword() {
      this.confirmDialogResetPassword = false
    },
    submitConfirmDialogResetPassword() {
      this.confirmDialogResetPassword = false
      this.isResetPassword = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_uuid: this.employee.employee_uuid,
      }

      this.$store
        .dispatch('employee/resetEmployeePassword', payload)
        .then(() => {
          this.isResetPassword = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'การรีเซ็ตรหัสผ่านของพนักงานสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.isResetPassword = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.onReset()
    },
    checkEmpty(value, field) {
      if (value) {
        this.employee[field] = value.trim()
      }
    },
    checkWfhLocationEmpty(value, field) {
      if (value) {
        this.wfhLocation[field] = value.trim()
      }
    },
    getTableRowIndex(index, page = 1, itemsPerPage = 5) {
      const safePage = Number(page) > 0 ? Number(page) : 1
      const safeItemsPerPage =
        Number(itemsPerPage) > 0 ? Number(itemsPerPage) : 5

      return (safePage - 1) * safeItemsPerPage + index + 1
    },
    formatCoordinate(value) {
      const coordinate = Number(value)
      return Number.isFinite(coordinate) ? coordinate.toFixed(4) : '-'
    },
    formatDateDisplay(value, timezone = null) {
      if (!value) {
        return '-'
      }

      const hasEmbeddedOffset =
        typeof value === 'string' && /(Z|[+-]\d{2}:\d{2})$/i.test(value.trim())

      let formattedDate = hasEmbeddedOffset
        ? moment.parseZone(value)
        : moment(value)

      if (timezone) {
        formattedDate = hasEmbeddedOffset
          ? formattedDate.utcOffset(timezone)
          : formattedDate.utcOffset(timezone, true)
      }

      return formattedDate.isValid() ? formattedDate.format('DD/MM/YYYY') : '-'
    },
    // moment.utcOffset() acts as a getter (returns a number, not a moment) when passed a falsy offset
    applyLocationTimezone(momentInstance, timezone) {
      return timezone
        ? momentInstance.utcOffset(timezone, true)
        : momentInstance
    },
    hasCompanyLocationSchedules(location) {
      return this.getCompanyLocationSchedules(location).length > 0
    },
    getCompanyLocationSchedules(location) {
      if (!Array.isArray(location?.schedules)) {
        return []
      }

      return location.schedules.filter(
        (schedule) => schedule?.start_at || schedule?.end_at
      )
    },
    formatCompanyLocationScheduleLabel(schedule, timezone = null) {
      const startDate = this.formatDateDisplay(schedule?.start_at, timezone)
      const endDate = this.formatDateDisplay(schedule?.end_at, timezone)
      const start = startDate !== '-' ? startDate : 'ไม่ระบุ'
      const end = endDate !== '-' ? endDate : 'ไม่ระบุ'
      return `${start} - ${end}`
    },
    getCompanyLocationFirstScheduleLabel(location) {
      const firstSchedule = this.getCompanyLocationSchedules(location)[0]

      if (!firstSchedule) {
        return '-'
      }

      return this.formatCompanyLocationScheduleLabel(
        firstSchedule,
        location?.timezone
      )
    },
    getCompanyLocationScheduleOverflowCount(location) {
      return Math.max(this.getCompanyLocationSchedules(location).length - 1, 0)
    },
    getCompanyLocationScheduleButtonLabel(location) {
      const overflowCount =
        this.getCompanyLocationScheduleOverflowCount(location)

      return overflowCount > 0 ? `+${overflowCount}` : 'เพิ่ม'
    },
    hasClientSiteLocationSchedules(location) {
      return this.getClientSiteLocationSchedules(location).length > 0
    },
    getClientSiteLocationSchedules(location) {
      if (!Array.isArray(location?.schedules)) {
        return []
      }

      return location.schedules.filter(
        (schedule) => schedule?.start_at || schedule?.end_at
      )
    },
    formatClientSiteLocationScheduleLabel(schedule, timezone = null) {
      const startDate = this.formatDateDisplay(schedule?.start_at, timezone)
      const endDate = this.formatDateDisplay(schedule?.end_at, timezone)
      const start = startDate !== '-' ? startDate : 'ไม่ระบุ'
      const end = endDate !== '-' ? endDate : 'ไม่ระบุ'
      return `${start} - ${end}`
    },
    getClientSiteLocationFirstScheduleLabel(location) {
      const firstSchedule = this.getClientSiteLocationSchedules(location)[0]

      if (!firstSchedule) {
        return '-'
      }

      return this.formatClientSiteLocationScheduleLabel(
        firstSchedule,
        location?.timezone
      )
    },
    getClientSiteLocationScheduleOverflowCount(location) {
      return Math.max(
        this.getClientSiteLocationSchedules(location).length - 1,
        0
      )
    },
    getClientSiteLocationScheduleButtonLabel(location) {
      const overflowCount =
        this.getClientSiteLocationScheduleOverflowCount(location)

      return overflowCount > 0 ? `+${overflowCount}` : 'เพิ่ม'
    },
    handleSerialChange() {
      this.serialValid = true
      this.serialMessageError = ''
    },
    handleOnClickBiometric(biometric) {
      this.$emit('onClickBiometric', biometric)
    },
    async onFileChange(file) {
      if (file) {
        this.fileImage = file
        const result = await this.getBase64(file)
        this.uploadFilePreview = result.split(',').pop()
      }
    },
    onFileClear() {
      this.fileImage = null
      this.uploadFilePreview = null
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    async onSubmit() {
      if (
        !this.employee.employee_code ||
        !this.employee.firstname_th ||
        !this.employee.lastname_th ||
        !this.employee.organization_uuid ||
        !this.employee.position_uuid ||
        !this.employee.employee_type_uuid
      ) {
        this.tabs = 0
        this.$refs?.form.validate()

        return
      } else if (!this.employee.shift_uuid) {
        this.tabs = 2
        this.$refs?.form.validate()

        return
      }

      if (this.$refs?.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          // verify card serial number
          if (this.employee.card.sn) {
            const cardSerialNumber = this.employee.card.sn.trim()
            const verifyPayload = {
              body: {
                company_uuid,
                serial_number: cardSerialNumber,
              },
            }
            const verifyResult = await this.verifyCardSerialNumber(
              verifyPayload
            )
            if (!_.isEmpty(verifyResult.employee)) {
              this.$store.state.loading = false

              this.serialValid = false
              this.serialMessageError = `หมายเลขบัตรนี้มีผู้ใช้แล้ว (${verifyResult?.employee?.employee_code} - ${verifyResult?.employee?.firstname_th} ${verifyResult?.employee?.lastname_th})`

              this.tabs = 1

              this.$nextTick(() => {
                this.$refs.serialInput.focus()
              })
              return
            }
          }

          let file_base64 = null
          let file_ext = null

          if (this.fileImage) {
            const result = await this.getBase64(this.fileImage)
            file_base64 = result.split(',').pop()
            file_ext = `.${this.fileImage.type.split('/').pop()}`
          }

          const newEmployee = {
            photo_identifier_extension: file_ext ? file_ext : null,
            photo_identifier: file_base64 ? file_base64 : null,
            organization_uuid: this.employee.organization_uuid,
            approval_organization_uuid:
              this.employee.approval_organization_uuid || null,
            position_uuid: this.employee.position_uuid,
            employee_level_uuid: this.employee.employee_level_uuid || null,
            employee_type_uuid: this.employee.employee_type_uuid,
            shift_uuid: this.employee.shift_uuid,
            employee_code: this.employee.employee_code,
            employee_reference_code:
              this.employee.employee_reference_code || null,
            ms_entraid_email: this.employee.ms_entraid_email || null,
            pin_code: this.employee.pin_code || null,
            firstname_th: this.employee.firstname_th,
            lastname_th: this.employee.lastname_th,
            firstname_en: this.employee.firstname_en
              ? this.employee.firstname_en
              : null,
            lastname_en: this.employee.lastname_en
              ? this.employee.lastname_en
              : null,
            gender_id: this.employee.gender_id || null,
            company_prefix_uuid: this.employee.company_prefix_uuid || null,
            phone_no: this.employee.phone_no ? this.employee.phone_no : null,
            email: this.employee.email ? this.employee.email : null,
            birthday: this.employee.birthday
              ? moment(this.employee.birthday).format('YYYY-MM-DD')
              : null,
            time_attendance_start_time: this.employee.time_attendance_start_time
              ? moment(this.employee.time_attendance_start_time).format()
              : null,
            time_attendance_end_time: this.employee.time_attendance_end_time
              ? moment(this.employee.time_attendance_end_time).format()
              : null,
            role_uuid: this.$store.state.role.roles[0].role_uuid,
            identify_mode:
              this.employee.identify_mode || this.employee.identify_mode === 0
                ? this.employee.identify_mode
                : 8,
            is_active: this.employee.is_active,
          }

          const {
            employee_uuid,
            time_attendance_offsite_grant: {
              time_attendance_offsite_grant_uuid,
            },
          } = await this.addEmployee({
            company_uuid,
            employee: newEmployee,
          })

          const cardApiPostList = []
          if (this.employee.card.sn) {
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPostList.push(
              this.addCard({
                company_uuid,
                body: {
                  employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid || null,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code ||
                        null,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          const biometricApiPutList = []
          const faceBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'face'
            )
          if (faceBiometric) {
            faceBiometric.biometric_property.forEach((face) => {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code: face.biometric_property_code,
                  body: {
                    ...face.employee_biometric,
                  },
                })
              )
            })
          }

          const fingerBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'fingerprint_secugen'
            )
          if (fingerBiometric) {
            fingerBiometric.biometric_property.forEach((finger) => {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code: finger.biometric_property_code,
                  body: {
                    ...finger.employee_biometric,
                  },
                })
              )
            })
          }

          const accessAuthoritiesApiPostList = []
          if (this.isAccessAuthorityDataChange) {
            accessAuthoritiesApiPostList.push(
              this.addEmployeeToAuthorities({
                company_uuid,
                body: {
                  employee_uuid,
                  authority_uuids: [...this.employee.authority],
                },
              })
            )
          }

          const timeAttendanceApiPutList = []
          if (this.isTimeAttendanceDataChange) {
            timeAttendanceApiPutList.push(
              this.editEmployeeTimeAttendance({
                company_uuid,
                employee_uuid,
                body: {
                  ...this.employee.time_attendance,
                  pass_probation_at: this.employee.time_attendance
                    .pass_probation_at
                    ? moment(
                        this.employee.time_attendance.pass_probation_at
                      ).format('YYYY-MM-DD')
                    : null,
                },
              })
            )
          }

          const timeAttendanceOffsiteGrantApiPutList = []
          if (this.isTimeAttendanceOffsiteGrantDataChange) {
            timeAttendanceOffsiteGrantApiPutList.push(
              this.editTimeAttendanceOffsiteGrant({
                company_uuid,
                time_attendance_offsite_grant_uuid,
                data: {
                  employee_uuid,
                  is_anywhere_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_anywhere_enabled || false,
                  anywhere_start_at: this.employee.time_attendance_offsite_grant
                    .anywhere_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .anywhere_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  anywhere_end_at: this.employee.time_attendance_offsite_grant
                    .anywhere_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .anywhere_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_company_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_company_enabled || false,
                  is_company_location_apply_all:
                    this.employee.time_attendance_offsite_grant
                      ?.is_company_location_apply_all || false,
                  company_start_at: this.employee.time_attendance_offsite_grant
                    .company_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .company_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  company_end_at: this.employee.time_attendance_offsite_grant
                    .company_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .company_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_client_site_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_client_site_enabled || false,
                  is_client_site_apply_all:
                    this.employee.time_attendance_offsite_grant
                      ?.is_client_site_apply_all || false,
                  client_site_start_at: this.employee
                    .time_attendance_offsite_grant.client_site_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .client_site_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  client_site_end_at: this.employee
                    .time_attendance_offsite_grant.client_site_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .client_site_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_wfh_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_wfh_enabled || false,
                  wfh_start_at: this.employee.time_attendance_offsite_grant
                    .wfh_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant.wfh_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  wfh_end_at: this.employee.time_attendance_offsite_grant
                    .wfh_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant.wfh_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_check_in_out_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_check_in_out_enabled || false,
                  check_in_out_start_at: this.employee
                    .time_attendance_offsite_grant.check_in_out_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .check_in_out_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  check_in_out_end_at: this.employee
                    .time_attendance_offsite_grant.check_in_out_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .check_in_out_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                },
              })
            )
          }

          const companyLocationApiPostList = []
          const companyLocations =
            this.employee.time_attendance_offsite_grant?.company_locations || []
          if (
            this.employee.time_attendance_offsite_grant
              ?.is_company_location_apply_all === false &&
            companyLocations.length > 0
          ) {
            const companyLocationUuids = companyLocations
              .map((location) => location?.company_location_uuid)
              .filter(Boolean)

            if (companyLocationUuids.length > 0) {
              companyLocationApiPostList.push(
                (async () => {
                  await this.addOffsiteGrantCompanyLocation({
                    company_uuid,
                    time_attendance_offsite_grant_uuid,
                    data: {
                      apply_all: false,
                      company_location_uuids: companyLocationUuids,
                    },
                  })

                  const locationsWithSchedules = companyLocations.filter(
                    (location) =>
                      Array.isArray(location?.schedules) &&
                      location.schedules.some(
                        (schedule) => schedule?.start_at || schedule?.end_at
                      )
                  )

                  if (locationsWithSchedules.length === 0) {
                    return
                  }

                  const locationsResponse =
                    await this.fetchOffsiteGrantCompanyLocations({
                      company_uuid,
                      time_attendance_offsite_grant_uuid,
                      params: { sort: 'title_th:desc' },
                    })
                  const locationsData = Array.isArray(
                    locationsResponse?.data?.data
                  )
                    ? locationsResponse.data.data
                    : Array.isArray(locationsResponse?.data)
                    ? locationsResponse.data
                    : []

                  const scheduleRequests = []
                  locationsWithSchedules.forEach((location) => {
                    const persistedLocation = locationsData.find(
                      (item) =>
                        item?.company_location_uuid ===
                        location?.company_location_uuid
                    )
                    const offsiteGrantCompanyLocationUuid =
                      location?.offsite_grant_company_location_uuid ||
                      persistedLocation?.offsite_grant_company_location_uuid

                    if (!offsiteGrantCompanyLocationUuid) {
                      throw new Error(
                        'ไม่พบ offsite_grant_company_location_uuid'
                      )
                    }

                    location.schedules
                      .filter(
                        (schedule) => schedule?.start_at || schedule?.end_at
                      )
                      .forEach((schedule) => {
                        const startAt = schedule.start_at
                          ? this.applyLocationTimezone(
                              moment(schedule.start_at),
                              location.timezone
                            ).format()
                          : null
                        const endAt = schedule.end_at
                          ? this.applyLocationTimezone(
                              moment(schedule.end_at),
                              location.timezone
                            )
                              .set({
                                hour: 23,
                                minute: 59,
                                second: 59,
                                millisecond: 0,
                              })
                              .format()
                          : null

                        scheduleRequests.push(
                          this.addCompanyLocationSchedule({
                            company_uuid,
                            time_attendance_offsite_grant_uuid,
                            offsite_grant_company_location_uuid:
                              offsiteGrantCompanyLocationUuid,
                            data: {
                              schedules: [
                                {
                                  start_at: startAt,
                                  end_at: endAt,
                                },
                              ],
                            },
                          })
                        )
                      })
                  })

                  await Promise.all(scheduleRequests)
                })()
              )
            }
          }

          const wfhLocationApiList = []
          if (this.isWfhLocationDataChange) {
            ;(this.employee.wfh_locations || []).forEach((wfhLocation) => {
              wfhLocationApiList.push(
                (async () => {
                  const createdLocation = await this.addWfhLocation({
                    company_uuid,
                    data: {
                      employee_uuid,
                      title_th: wfhLocation.title_th,
                      title_en: wfhLocation.title_en,
                      latitude: wfhLocation.latitude,
                      longitude: wfhLocation.longitude,
                      radius_meter: parseInt(wfhLocation.radius_meter, 10),
                      timezone: wfhLocation.timezone,
                      is_active: true,
                    },
                  })

                  const createdLocationData =
                    createdLocation?.data || createdLocation || {}
                  const wfhLocationUuid =
                    createdLocationData.wfh_location_uuid ||
                    wfhLocation.wfh_location_uuid
                  const schedules = Array.isArray(wfhLocation.schedules)
                    ? wfhLocation.schedules.filter(
                        (schedule) => schedule?.start_at || schedule?.end_at
                      )
                    : []

                  if (!wfhLocationUuid || schedules.length === 0) {
                    return
                  }

                  await Promise.all(
                    schedules.map((schedule) => {
                      const startAt = schedule.start_at
                        ? this.applyLocationTimezone(
                            moment(schedule.start_at),
                            wfhLocation.timezone
                          ).format()
                        : null
                      const endAt = schedule.end_at
                        ? this.applyLocationTimezone(
                            moment(schedule.end_at),
                            wfhLocation.timezone
                          )
                            .set({
                              hour: 23,
                              minute: 59,
                              second: 59,
                              millisecond: 0,
                            })
                            .format()
                        : null

                      return this.addWfhLocationSchedule({
                        company_uuid,
                        time_attendance_offsite_grant_uuid,
                        wfh_location_uuid: wfhLocationUuid,
                        data: {
                          schedules: [
                            {
                              start_at: startAt,
                              end_at: endAt,
                            },
                          ],
                        },
                      })
                    })
                  )
                })()
              )
            })
          }

          const clientSiteLocationApiPostList = []
          const clientSiteLocations =
            this.employee.time_attendance_offsite_grant
              ?.client_site_locations || []
          if (
            this.employee.time_attendance_offsite_grant
              ?.is_client_site_apply_all === false &&
            clientSiteLocations.length > 0
          ) {
            const clientSiteLocationUuids = clientSiteLocations
              .map((location) => location?.client_site_location_uuid)
              .filter(Boolean)

            if (clientSiteLocationUuids.length > 0) {
              clientSiteLocationApiPostList.push(
                (async () => {
                  await this.addOffsiteGrantClientSiteLocation({
                    company_uuid,
                    time_attendance_offsite_grant_uuid,
                    data: {
                      apply_all: false,
                      client_site_location_uuids: clientSiteLocationUuids,
                    },
                  })

                  const locationsWithSchedules = clientSiteLocations.filter(
                    (location) =>
                      Array.isArray(location?.schedules) &&
                      location.schedules.some(
                        (schedule) => schedule?.start_at || schedule?.end_at
                      )
                  )

                  if (locationsWithSchedules.length === 0) {
                    return
                  }

                  const locationsResponse =
                    await this.fetchOffsiteGrantClientSiteLocations({
                      company_uuid,
                      time_attendance_offsite_grant_uuid,
                      params: { sort: 'title_th:asc' },
                    })
                  const locationsData = Array.isArray(
                    locationsResponse?.data?.data
                  )
                    ? locationsResponse.data.data
                    : Array.isArray(locationsResponse?.data)
                    ? locationsResponse.data
                    : []

                  const scheduleRequests = []
                  locationsWithSchedules.forEach((location) => {
                    const persistedLocation = locationsData.find(
                      (item) =>
                        item?.client_site_location_uuid ===
                        location?.client_site_location_uuid
                    )
                    const offsiteGrantClientSiteLocationUuid =
                      location?.offsite_grant_client_site_location_uuid ||
                      persistedLocation?.offsite_grant_client_site_location_uuid

                    if (!offsiteGrantClientSiteLocationUuid) {
                      throw new Error(
                        'ไม่พบ offsite_grant_client_site_location_uuid'
                      )
                    }

                    location.schedules
                      .filter(
                        (schedule) => schedule?.start_at || schedule?.end_at
                      )
                      .forEach((schedule) => {
                        const startAt = schedule.start_at
                          ? this.applyLocationTimezone(
                              moment(schedule.start_at),
                              location.timezone
                            ).format()
                          : null
                        const endAt = schedule.end_at
                          ? this.applyLocationTimezone(
                              moment(schedule.end_at),
                              location.timezone
                            )
                              .set({
                                hour: 23,
                                minute: 59,
                                second: 59,
                                millisecond: 0,
                              })
                              .format()
                          : null

                        scheduleRequests.push(
                          this.addClientSiteSchedule({
                            company_uuid,
                            time_attendance_offsite_grant_uuid,
                            offsite_grant_client_site_location_uuid:
                              offsiteGrantClientSiteLocationUuid,
                            data: {
                              schedules: [
                                {
                                  start_at: startAt,
                                  end_at: endAt,
                                },
                              ],
                            },
                          })
                        )
                      })
                  })

                  await Promise.all(scheduleRequests)
                })()
              )
            }
          }

          await Promise.all([
            ...cardApiPostList,
            ...biometricApiPutList,
            ...accessAuthoritiesApiPostList,
            ...timeAttendanceApiPutList,
            ...wfhLocationApiList,
            ...timeAttendanceOffsiteGrantApiPutList,
            ...companyLocationApiPostList,
            ...clientSiteLocationApiPostList,
          ])

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.fileImage = null
          this.uploadFilePreview = null
          this.serialValid = true
          this.serialMessageError = ''

          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (
        !this.employee.employee_code ||
        !this.employee.firstname_th ||
        !this.employee.lastname_th ||
        !this.employee.organization_uuid ||
        !this.employee.position_uuid ||
        !this.employee.employee_type_uuid
      ) {
        this.tabs = 0
        this.$refs?.form.validate()

        return
      } else if (!this.employee.shift_uuid) {
        this.tabs = 2
        this.$refs?.form.validate()

        return
      }

      if (this.$refs?.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          // verify card serial number
          if (
            this.employeeInit.card.sn !== this.employee.card.sn &&
            this.employee.card.sn
          ) {
            const cardSerialNumber = this.employee.card.sn.trim()
            const verifyPayload = {
              body: {
                company_uuid,
                serial_number: cardSerialNumber,
              },
            }
            const verifyResult = await this.verifyCardSerialNumber(
              verifyPayload
            )
            if (!_.isEmpty(verifyResult.employee)) {
              this.$store.state.loading = false

              this.serialValid = false
              this.serialMessageError = `หมายเลขบัตรนี้มีผู้ใช้แล้ว (${verifyResult?.employee?.employee_code} - ${verifyResult?.employee?.firstname_th} ${verifyResult?.employee?.lastname_th})`

              this.tabs = 1

              this.$nextTick(() => {
                this.$refs.serialInput.focus()
              })
              return
            }
          }

          let file_base64 = null
          let file_ext = null

          if (this.fileImage) {
            const result = await this.getBase64(this.fileImage)
            file_base64 = result.split(',').pop()
            file_ext = `.${this.fileImage.type.split('/').pop()}`
          }

          const updatedEmployee = {
            photo_identifier_extension: file_ext ? file_ext : null,
            photo_identifier: file_base64 ? file_base64 : null,
            organization_uuid: this.employee.organization_uuid,
            approval_organization_uuid:
              this.employee.approval_organization_uuid || null,
            position_uuid: this.employee.position_uuid,
            employee_level_uuid: this.employee.employee_level_uuid || null,
            employee_type_uuid: this.employee.employee_type_uuid,
            shift_uuid: this.employee.shift_uuid,
            employee_code: this.employee.employee_code,
            employee_reference_code:
              this.employee.employee_reference_code || null,
            ms_entraid_email: this.employee.ms_entraid_email || null,
            pin_code: this.employee.pin_code || null,
            firstname_th: this.employee.firstname_th,
            lastname_th: this.employee.lastname_th,
            firstname_en: this.employee.firstname_en
              ? this.employee.firstname_en
              : null,
            lastname_en: this.employee.lastname_en
              ? this.employee.lastname_en
              : null,
            gender_id: this.employee.gender_id || null,
            company_prefix_uuid: this.employee.company_prefix_uuid || null,
            phone_no: this.employee.phone_no ? this.employee.phone_no : null,
            email: this.employee.email ? this.employee.email : null,
            birthday: this.employee.birthday
              ? moment(this.employee.birthday).format('YYYY-MM-DD')
              : null,
            resign_date: this.employee.resign_date
              ? moment(this.employee.resign_date).format('YYYY-MM-DD')
              : null,
            time_attendance_start_time: this.employee.time_attendance_start_time
              ? moment(this.employee.time_attendance_start_time).format()
              : null,
            time_attendance_end_time: this.employee.time_attendance_end_time
              ? moment(this.employee.time_attendance_end_time).format()
              : null,
            role_uuid: this.$store.state.role.roles[0].role_uuid,
            identify_mode:
              this.employee.identify_mode || this.employee.identify_mode === 0
                ? this.employee.identify_mode
                : 8,
            is_active: this.employee.is_active,
          }

          const employeeApiPutList = []
          if (
            this.isTabEmployeeGeneralDataChange ||
            this.isTabEmployeeTimeAttendanceDataChange ||
            this.employee.pin_code !== this.employeeInit.pin_code ||
            this.employee.identify_mode !== this.employeeInit.identify_mode
          ) {
            // edit employee
            employeeApiPutList.push(
              this.editEmployee({
                company_uuid,
                employee_uuid: this.employee.employee_uuid,
                employee: updatedEmployee,
              })
            )
          }

          const cardApiPutList = []
          if (!this.employeeInit.card.sn && this.employee.card.sn) {
            // add card
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPutList.push(
              this.addCard({
                company_uuid,
                body: {
                  employee_uuid: this.employee.employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          if (
            this.employeeInit.card.sn &&
            this.employeeInit.card.sn !== this.employee.card.sn &&
            this.employee.card.sn
          ) {
            // edit card
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPutList.push(
              this.editCard({
                company_uuid,
                card_uuid: this.employee.card.card_uuid,
                body: {
                  employee_uuid: this.employee.employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_uuid:
                        this.employee.card.card_identifier_uuid,
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          if (this.employeeInit.card.sn && !this.employee.card.sn) {
            // delete card
            cardApiPutList.push(
              this.deleteCard({
                company_uuid,
                card_uuid: this.employee.card.card_uuid,
              })
            )
          }

          const biometricApiPutList = []
          const faceBiometricInit = this.employeeInit.biometric.find(
            (e) => e.biometric_code === 'face'
          )
          const faceBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'face'
            )
          if (
            JSON.stringify(faceBiometricInit) !== JSON.stringify(faceBiometric)
          ) {
            if (faceBiometric.biometric_property.length > 0) {
              // edit face biometric
              faceBiometric.biometric_property.forEach((face) => {
                biometricApiPutList.push(
                  this.$store.dispatch('employee/editEmployeeBiometric', {
                    company_uuid,
                    employee_uuid: this.employee.employee_uuid,
                    biometric_property_code: face.biometric_property_code,
                    body: {
                      ...face.employee_biometric,
                    },
                  })
                )
              })
            }
            if (faceBiometric.biometric_property.length === 0) {
              // delete face biometric
              faceBiometricInit.biometric_property.forEach((face) => {
                biometricApiPutList.push(
                  this.$store.dispatch('employee/deleteEmployeeBiometric', {
                    company_uuid,
                    employee_uuid: this.employee.employee_uuid,
                    biometric_property_code: face.biometric_property_code,
                  })
                )
              })
            }
          }
          const fingerInit = this.employeeInit.biometric.find(
            (e) => e.biometric_code === 'fingerprint_secugen'
          )
          const fingerInitSecugen1 = fingerInit?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_1'
          )
          const fingerInitSecugen2 = fingerInit?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_2'
          )
          const finger = this.$store.state.employee.employeeBiometric.find(
            (e) => e.biometric_code === 'fingerprint_secugen'
          )
          const fingerSecugen1 = finger?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_1'
          )
          const fingerSecugen2 = finger?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_2'
          )
          if (JSON.stringify(fingerInit) !== JSON.stringify(finger)) {
            if (fingerInitSecugen1 && !fingerSecugen1) {
              // delete finger secugen 1
              biometricApiPutList.push(
                this.$store.dispatch('employee/deleteEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code: 'fingerprint_secugen_1',
                })
              )
            }
            if (fingerInitSecugen2 && !fingerSecugen2) {
              // delete finger secugen 2
              biometricApiPutList.push(
                this.$store.dispatch('employee/deleteEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code: 'fingerprint_secugen_2',
                })
              )
            }
            if (fingerSecugen1 && fingerSecugen1 !== fingerInitSecugen1) {
              // edit finger secugen 1
              biometricApiPutList.push(
                this.$store.dispatch('employee/editEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code:
                    fingerSecugen1.biometric_property_code,
                  body: {
                    ...fingerSecugen1.employee_biometric,
                  },
                })
              )
            }
            if (fingerSecugen2 && fingerSecugen2 !== fingerInitSecugen2) {
              // edit finger secugen 2
              biometricApiPutList.push(
                this.$store.dispatch('employee/editEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code:
                    fingerSecugen2.biometric_property_code,
                  body: {
                    ...fingerSecugen2.employee_biometric,
                  },
                })
              )
            }
          }

          const accessAuthoritiesApiPutList = []
          if (this.isAccessAuthorityDataChange) {
            accessAuthoritiesApiPutList.push(
              this.editEmployeeToAuthorities({
                company_uuid,
                body: {
                  employee_uuid: this.employee.employee_uuid,
                  authority_uuids: [...this.employee.authority],
                },
              })
            )
          }

          const timeAttendanceApiPutList = []
          if (this.isTimeAttendanceDataChange) {
            timeAttendanceApiPutList.push(
              this.editEmployeeTimeAttendance({
                company_uuid,
                employee_uuid: this.employee.employee_uuid,
                body: {
                  ...this.employee.time_attendance,
                  pass_probation_at: this.employee.time_attendance
                    .pass_probation_at
                    ? moment(
                        this.employee.time_attendance.pass_probation_at
                      ).format('YYYY-MM-DD')
                    : null,
                },
              })
            )
          }

          const timeAttendanceOffsiteGrantApiPutList = []
          if (this.isTimeAttendanceOffsiteGrantDataChange) {
            timeAttendanceOffsiteGrantApiPutList.push(
              this.editTimeAttendanceOffsiteGrant({
                company_uuid,
                time_attendance_offsite_grant_uuid:
                  this.employee.time_attendance_offsite_grant
                    .time_attendance_offsite_grant_uuid,
                data: {
                  employee_uuid: this.employee.employee_uuid,
                  is_anywhere_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_anywhere_enabled || false,
                  anywhere_start_at: this.employee.time_attendance_offsite_grant
                    .anywhere_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .anywhere_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  anywhere_end_at: this.employee.time_attendance_offsite_grant
                    .anywhere_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .anywhere_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_company_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_company_enabled || false,
                  is_company_location_apply_all:
                    this.employee.time_attendance_offsite_grant
                      ?.is_company_location_apply_all || false,
                  company_start_at: this.employee.time_attendance_offsite_grant
                    .company_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .company_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  company_end_at: this.employee.time_attendance_offsite_grant
                    .company_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .company_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_client_site_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_client_site_enabled || false,
                  is_client_site_apply_all:
                    this.employee.time_attendance_offsite_grant
                      ?.is_client_site_apply_all || false,
                  client_site_start_at: this.employee
                    .time_attendance_offsite_grant.client_site_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .client_site_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  client_site_end_at: this.employee
                    .time_attendance_offsite_grant.client_site_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .client_site_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_wfh_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_wfh_enabled || false,
                  wfh_start_at: this.employee.time_attendance_offsite_grant
                    .wfh_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant.wfh_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  wfh_end_at: this.employee.time_attendance_offsite_grant
                    .wfh_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant.wfh_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                  is_check_in_out_enabled:
                    this.employee.time_attendance_offsite_grant
                      ?.is_check_in_out_enabled || false,
                  check_in_out_start_at: this.employee
                    .time_attendance_offsite_grant.check_in_out_start_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .check_in_out_start_at
                      )
                        .startOf('day')
                        .format()
                    : null,
                  check_in_out_end_at: this.employee
                    .time_attendance_offsite_grant.check_in_out_end_at
                    ? moment(
                        this.employee.time_attendance_offsite_grant
                          .check_in_out_end_at
                      )
                        .endOf('day')
                        .format()
                    : null,
                },
              })
            )
          }

          const wfhLocationApiList = []
          if (this.isWfhLocationDataChange) {
            const initWfhLocations = this.employeeInit.wfh_locations || []
            const currentWfhLocations = this.employee.wfh_locations || []

            const initWfhLocationByUuid = new Map(
              initWfhLocations
                .filter((location) => !!location.wfh_location_uuid)
                .map((location) => [location.wfh_location_uuid, location])
            )
            const currentWfhLocationByUuid = new Map(
              currentWfhLocations
                .filter((location) => !!location.wfh_location_uuid)
                .map((location) => [location.wfh_location_uuid, location])
            )

            // add/edit locations from current state
            currentWfhLocations.forEach((location) => {
              const currentUuid = location.wfh_location_uuid
              const initLocation = currentUuid
                ? initWfhLocationByUuid.get(currentUuid)
                : null

              if (!initLocation) {
                wfhLocationApiList.push(
                  this.addWfhLocation({
                    company_uuid,
                    data: {
                      employee_uuid: this.employee.employee_uuid,
                      title_th: location.title_th,
                      title_en: location.title_en,
                      latitude: location.latitude,
                      longitude: location.longitude,
                      radius_meter: parseInt(location.radius_meter, 10),
                      timezone: location.timezone,
                      is_active: true,
                    },
                  })
                )
                return
              }

              if (!_.isEqual(location, initLocation)) {
                wfhLocationApiList.push(
                  this.editWfhLocation({
                    company_uuid,
                    wfh_location_uuid: currentUuid,
                    data: {
                      employee_uuid: this.employee.employee_uuid,
                      title_th: location.title_th,
                      title_en: location.title_en,
                      latitude: location.latitude,
                      longitude: location.longitude,
                      radius_meter: parseInt(location.radius_meter, 10),
                      timezone: location.timezone,
                      is_active: true,
                    },
                  })
                )
              }
            })

            // delete locations removed from current state
            initWfhLocations.forEach((location) => {
              if (!currentWfhLocationByUuid.has(location.wfh_location_uuid)) {
                wfhLocationApiList.push(
                  this.deleteWfhLocation({
                    company_uuid,
                    wfh_location_uuid: location.wfh_location_uuid,
                  })
                )
              }
            })
          }

          await Promise.all([
            ...employeeApiPutList,
            ...cardApiPutList,
            ...biometricApiPutList,
            ...accessAuthoritiesApiPutList,
            ...timeAttendanceApiPutList,
            ...timeAttendanceOffsiteGrantApiPutList,
            ...wfhLocationApiList,
          ])

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.fileImage = null
          this.uploadFilePreview = null
          this.serialValid = true
          this.serialMessageError = ''

          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onClose() {
      if (this.isEmployeeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.onReset()
      }
    },
    onReset() {
      this.$refs.form.resetValidation()
      this.fileImage = null
      this.uploadFilePreview = null
      this.serialValid = true
      this.serialMessageError = ''

      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
